/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type GroupLfInput = {
  id?: string | null,
  name?: string | null,
  memo?: string | null,
  groups?: string | null,
};

export type Response = {
  __typename: "Response",
  statusCode: string,
  headers?: string | null,
  body?: string | null,
  isBase64Encoded?: string | null,
};

export type UserLfInput = {
  id?: string | null,
  group_id?: string | null,
  name?: string | null,
  email?: string | null,
  role?: ConsoleRoleType | null,
  is_personal_data_handler?: boolean | null,
  groups?: string | null,
};

export enum ConsoleRoleType {
  ADMINISTRATOR = "ADMINISTRATOR",
  ASMARQUSER = "ASMARQUSER",
  GROUPMANAGER = "GROUPMANAGER",
  GROUPUSER = "GROUPUSER",
}


export type ChatTokenLfInput = {
  id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  last_event_dates_id?: string | null,
  last_event_dates_updatedAt?: string | null,
  typing_chat_data_id?: string | null,
  read_index_id?: string | null,
  refreshed_at?: string | null,
  groups?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type CreateGroupInput = {
  id?: string | null,
  name: string,
  memo?: string | null,
  groups?: string | null,
};

export type ModelGroupConditionInput = {
  name?: ModelStringInput | null,
  memo?: ModelStringInput | null,
  and?: Array< ModelGroupConditionInput | null > | null,
  or?: Array< ModelGroupConditionInput | null > | null,
  not?: ModelGroupConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type Group = {
  __typename: "Group",
  id: string,
  name: string,
  memo?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateGroupInput = {
  id: string,
  name?: string | null,
  memo?: string | null,
  groups?: string | null,
};

export type DeleteGroupInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  group_id: string,
  name: string,
  email: string,
  role: ConsoleRoleType,
  is_personal_data_handler?: boolean | null,
  groups?: string | null,
};

export type ModelUserConditionInput = {
  group_id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  role?: ModelConsoleRoleTypeInput | null,
  is_personal_data_handler?: ModelBooleanInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelConsoleRoleTypeInput = {
  eq?: ConsoleRoleType | null,
  ne?: ConsoleRoleType | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type User = {
  __typename: "User",
  id: string,
  group_id: string,
  name: string,
  email: string,
  role: ConsoleRoleType,
  is_personal_data_handler?: boolean | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUserInput = {
  id: string,
  group_id?: string | null,
  name?: string | null,
  email?: string | null,
  role?: ConsoleRoleType | null,
  is_personal_data_handler?: boolean | null,
  groups?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateSubjectInput = {
  id?: string | null,
  group_id: string,
  subject_seq: number,
  subject_number: string,
  subject_name?: string | null,
  subject_description?: string | null,
  subject_purpose?: string | null,
  interview_type?: InterviewType | null,
  start_date?: string | null,
  end_date?: string | null,
  input_expiration_date?: string | null,
  expiration_date?: string | null,
  main_user_id_group?: string | null,
  main_user_id_asmarq?: string | null,
  memo?: string | null,
  canceled: number,
  finished?: number | null,
  groups?: string | null,
};

export enum InterviewType {
  ONE_TIME = "ONE_TIME",
  TERM = "TERM",
}


export type ModelSubjectConditionInput = {
  group_id?: ModelIDInput | null,
  subject_seq?: ModelIntInput | null,
  subject_number?: ModelStringInput | null,
  subject_name?: ModelStringInput | null,
  subject_description?: ModelStringInput | null,
  subject_purpose?: ModelStringInput | null,
  interview_type?: ModelInterviewTypeInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  input_expiration_date?: ModelStringInput | null,
  expiration_date?: ModelStringInput | null,
  main_user_id_group?: ModelIDInput | null,
  main_user_id_asmarq?: ModelIDInput | null,
  memo?: ModelStringInput | null,
  canceled?: ModelIntInput | null,
  finished?: ModelIntInput | null,
  and?: Array< ModelSubjectConditionInput | null > | null,
  or?: Array< ModelSubjectConditionInput | null > | null,
  not?: ModelSubjectConditionInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelInterviewTypeInput = {
  eq?: InterviewType | null,
  ne?: InterviewType | null,
};

export type Subject = {
  __typename: "Subject",
  id: string,
  group_id: string,
  subject_seq: number,
  subject_number: string,
  subject_name?: string | null,
  subject_description?: string | null,
  subject_purpose?: string | null,
  interview_type?: InterviewType | null,
  start_date?: string | null,
  end_date?: string | null,
  input_expiration_date?: string | null,
  expiration_date?: string | null,
  main_user_id_group?: string | null,
  main_user_id_asmarq?: string | null,
  memo?: string | null,
  canceled: number,
  finished?: number | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSubjectInput = {
  id: string,
  group_id?: string | null,
  subject_seq?: number | null,
  subject_number?: string | null,
  subject_name?: string | null,
  subject_description?: string | null,
  subject_purpose?: string | null,
  interview_type?: InterviewType | null,
  start_date?: string | null,
  end_date?: string | null,
  input_expiration_date?: string | null,
  expiration_date?: string | null,
  main_user_id_group?: string | null,
  main_user_id_asmarq?: string | null,
  memo?: string | null,
  canceled?: number | null,
  finished?: number | null,
  groups?: string | null,
};

export type DeleteSubjectInput = {
  id: string,
};

export type CreateMarkedSubjectInput = {
  id?: string | null,
  user_id: string,
  subject_id: string,
  groups?: string | null,
};

export type ModelMarkedSubjectConditionInput = {
  user_id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  and?: Array< ModelMarkedSubjectConditionInput | null > | null,
  or?: Array< ModelMarkedSubjectConditionInput | null > | null,
  not?: ModelMarkedSubjectConditionInput | null,
};

export type MarkedSubject = {
  __typename: "MarkedSubject",
  id: string,
  user_id: string,
  subject_id: string,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMarkedSubjectInput = {
  id: string,
  user_id?: string | null,
  subject_id?: string | null,
  groups?: string | null,
};

export type DeleteMarkedSubjectInput = {
  id: string,
};

export type CreateInterviewInput = {
  id?: string | null,
  subject_id: string,
  interview_seq: number,
  interview_type?: InterviewType | null,
  scheduled_start_date?: string | null,
  scheduled_end_date?: string | null,
  scheduled_start_time?: string | null,
  scheduled_end_time?: string | null,
  actual_start_date?: string | null,
  actual_end_date?: string | null,
  actual_start_time?: string | null,
  actual_end_time?: string | null,
  canceled: number,
  memo?: string | null,
  note?: string | null,
  groups?: string | null,
};

export type ModelInterviewConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_seq?: ModelIntInput | null,
  interview_type?: ModelInterviewTypeInput | null,
  scheduled_start_date?: ModelStringInput | null,
  scheduled_end_date?: ModelStringInput | null,
  scheduled_start_time?: ModelStringInput | null,
  scheduled_end_time?: ModelStringInput | null,
  actual_start_date?: ModelStringInput | null,
  actual_end_date?: ModelStringInput | null,
  actual_start_time?: ModelStringInput | null,
  actual_end_time?: ModelStringInput | null,
  canceled?: ModelIntInput | null,
  memo?: ModelStringInput | null,
  note?: ModelStringInput | null,
  and?: Array< ModelInterviewConditionInput | null > | null,
  or?: Array< ModelInterviewConditionInput | null > | null,
  not?: ModelInterviewConditionInput | null,
};

export type Interview = {
  __typename: "Interview",
  id: string,
  subject_id: string,
  interview_seq: number,
  interview_type?: InterviewType | null,
  scheduled_start_date?: string | null,
  scheduled_end_date?: string | null,
  scheduled_start_time?: string | null,
  scheduled_end_time?: string | null,
  actual_start_date?: string | null,
  actual_end_date?: string | null,
  actual_start_time?: string | null,
  actual_end_time?: string | null,
  canceled: number,
  memo?: string | null,
  note?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateInterviewInput = {
  id: string,
  subject_id?: string | null,
  interview_seq?: number | null,
  interview_type?: InterviewType | null,
  scheduled_start_date?: string | null,
  scheduled_end_date?: string | null,
  scheduled_start_time?: string | null,
  scheduled_end_time?: string | null,
  actual_start_date?: string | null,
  actual_end_date?: string | null,
  actual_start_time?: string | null,
  actual_end_time?: string | null,
  canceled?: number | null,
  memo?: string | null,
  note?: string | null,
  groups?: string | null,
};

export type DeleteInterviewInput = {
  id: string,
};

export type CreateFileResourceInput = {
  id?: string | null,
  subject_id: string,
  sort_index: number,
  file_name: string,
  title: string,
  type: ResourceType,
  url: string,
  description?: string | null,
  groups?: string | null,
};

export enum ResourceType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}


export type ModelFileResourceConditionInput = {
  subject_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  file_name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelResourceTypeInput | null,
  url?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFileResourceConditionInput | null > | null,
  or?: Array< ModelFileResourceConditionInput | null > | null,
  not?: ModelFileResourceConditionInput | null,
};

export type ModelResourceTypeInput = {
  eq?: ResourceType | null,
  ne?: ResourceType | null,
};

export type FileResource = {
  __typename: "FileResource",
  id: string,
  subject_id: string,
  sort_index: number,
  file_name: string,
  title: string,
  type: ResourceType,
  url: string,
  description?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFileResourceInput = {
  id: string,
  subject_id?: string | null,
  sort_index?: number | null,
  file_name?: string | null,
  title?: string | null,
  type?: ResourceType | null,
  url?: string | null,
  description?: string | null,
  groups?: string | null,
};

export type DeleteFileResourceInput = {
  id: string,
};

export type CreateScenarioInput = {
  id?: string | null,
  subject_id: string,
  sort_index: number,
  scenario_no: number,
  template_no: number,
  text?: string | null,
  groups?: string | null,
};

export type ModelScenarioConditionInput = {
  subject_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  scenario_no?: ModelIntInput | null,
  template_no?: ModelIntInput | null,
  text?: ModelStringInput | null,
  and?: Array< ModelScenarioConditionInput | null > | null,
  or?: Array< ModelScenarioConditionInput | null > | null,
  not?: ModelScenarioConditionInput | null,
};

export type Scenario = {
  __typename: "Scenario",
  id: string,
  subject_id: string,
  sort_index: number,
  scenario_no: number,
  template_no: number,
  text?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateScenarioInput = {
  id: string,
  subject_id?: string | null,
  sort_index?: number | null,
  scenario_no?: number | null,
  template_no?: number | null,
  text?: string | null,
  groups?: string | null,
};

export type DeleteScenarioInput = {
  id: string,
};

export type CreateMonitorInput = {
  id?: string | null,
  subject_id: string,
  ans_id: string,
  classification?: string | null,
  member_id?: string | null,
  name?: string | null,
  sex?: string | null,
  age?: string | null,
  address?: string | null,
  marriage?: string | null,
  children?: string | null,
  job?: string | null,
  memo?: string | null,
  sort_index?: number | null,
  groups?: string | null,
};

export type ModelMonitorConditionInput = {
  subject_id?: ModelIDInput | null,
  ans_id?: ModelStringInput | null,
  classification?: ModelStringInput | null,
  member_id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  sex?: ModelStringInput | null,
  age?: ModelStringInput | null,
  address?: ModelStringInput | null,
  marriage?: ModelStringInput | null,
  children?: ModelStringInput | null,
  job?: ModelStringInput | null,
  memo?: ModelStringInput | null,
  sort_index?: ModelIntInput | null,
  and?: Array< ModelMonitorConditionInput | null > | null,
  or?: Array< ModelMonitorConditionInput | null > | null,
  not?: ModelMonitorConditionInput | null,
};

export type Monitor = {
  __typename: "Monitor",
  id: string,
  subject_id: string,
  ans_id: string,
  classification?: string | null,
  member_id?: string | null,
  name?: string | null,
  sex?: string | null,
  age?: string | null,
  address?: string | null,
  marriage?: string | null,
  children?: string | null,
  job?: string | null,
  memo?: string | null,
  sort_index?: number | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMonitorInput = {
  id: string,
  subject_id?: string | null,
  ans_id?: string | null,
  classification?: string | null,
  member_id?: string | null,
  name?: string | null,
  sex?: string | null,
  age?: string | null,
  address?: string | null,
  marriage?: string | null,
  children?: string | null,
  job?: string | null,
  memo?: string | null,
  sort_index?: number | null,
  groups?: string | null,
};

export type DeleteMonitorInput = {
  id: string,
};

export type CreateMonitorAssignInput = {
  id?: string | null,
  subject_id: string,
  monitor_id: string,
  interview_id: string,
  pin?: string | null,
  last_entry_date?: string | null,
  groups?: string | null,
};

export type ModelMonitorAssignConditionInput = {
  subject_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  pin?: ModelStringInput | null,
  last_entry_date?: ModelStringInput | null,
  and?: Array< ModelMonitorAssignConditionInput | null > | null,
  or?: Array< ModelMonitorAssignConditionInput | null > | null,
  not?: ModelMonitorAssignConditionInput | null,
};

export type MonitorAssign = {
  __typename: "MonitorAssign",
  id: string,
  subject_id: string,
  monitor_id: string,
  interview_id: string,
  pin?: string | null,
  last_entry_date?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMonitorAssignInput = {
  id: string,
  subject_id?: string | null,
  monitor_id?: string | null,
  interview_id?: string | null,
  pin?: string | null,
  last_entry_date?: string | null,
  groups?: string | null,
};

export type DeleteMonitorAssignInput = {
  id: string,
};

export type CreateMonitorAttributeInput = {
  id?: string | null,
  subject_id: string,
  monitor_id: string,
  seq_no: number,
  name: string,
  value?: string | null,
  groups?: string | null,
};

export type ModelMonitorAttributeConditionInput = {
  subject_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  seq_no?: ModelIntInput | null,
  name?: ModelStringInput | null,
  value?: ModelStringInput | null,
  and?: Array< ModelMonitorAttributeConditionInput | null > | null,
  or?: Array< ModelMonitorAttributeConditionInput | null > | null,
  not?: ModelMonitorAttributeConditionInput | null,
};

export type MonitorAttribute = {
  __typename: "MonitorAttribute",
  id: string,
  subject_id: string,
  monitor_id: string,
  seq_no: number,
  name: string,
  value?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMonitorAttributeInput = {
  id: string,
  subject_id?: string | null,
  monitor_id?: string | null,
  seq_no?: number | null,
  name?: string | null,
  value?: string | null,
  groups?: string | null,
};

export type DeleteMonitorAttributeInput = {
  id: string,
};

export type CreateMonitorCheckResultInput = {
  id?: string | null,
  monitor_id: string,
  subject_id: string,
  interview_id: string,
  initial_name?: string | null,
  initial_sex?: string | null,
  initial_age?: string | null,
  initial_address?: string | null,
  initial_marriage?: string | null,
  initial_children?: string | null,
  initial_job?: string | null,
  monitor_check_result_type?: MonitorCheckResultType | null,
  submitted_text?: string | null,
};

export enum MonitorCheckResultType {
  CHECKED = "CHECKED",
  NOT_CHECKED = "NOT_CHECKED",
  FIXED = "FIXED",
}


export type ModelMonitorCheckResultConditionInput = {
  monitor_id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  initial_name?: ModelStringInput | null,
  initial_sex?: ModelStringInput | null,
  initial_age?: ModelStringInput | null,
  initial_address?: ModelStringInput | null,
  initial_marriage?: ModelStringInput | null,
  initial_children?: ModelStringInput | null,
  initial_job?: ModelStringInput | null,
  monitor_check_result_type?: ModelMonitorCheckResultTypeInput | null,
  submitted_text?: ModelStringInput | null,
  and?: Array< ModelMonitorCheckResultConditionInput | null > | null,
  or?: Array< ModelMonitorCheckResultConditionInput | null > | null,
  not?: ModelMonitorCheckResultConditionInput | null,
};

export type ModelMonitorCheckResultTypeInput = {
  eq?: MonitorCheckResultType | null,
  ne?: MonitorCheckResultType | null,
};

export type MonitorCheckResult = {
  __typename: "MonitorCheckResult",
  id: string,
  monitor_id: string,
  subject_id: string,
  interview_id: string,
  initial_name?: string | null,
  initial_sex?: string | null,
  initial_age?: string | null,
  initial_address?: string | null,
  initial_marriage?: string | null,
  initial_children?: string | null,
  initial_job?: string | null,
  monitor_check_result_type?: MonitorCheckResultType | null,
  submitted_text?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMonitorCheckResultInput = {
  id: string,
  monitor_id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  initial_name?: string | null,
  initial_sex?: string | null,
  initial_age?: string | null,
  initial_address?: string | null,
  initial_marriage?: string | null,
  initial_children?: string | null,
  initial_job?: string | null,
  monitor_check_result_type?: MonitorCheckResultType | null,
  submitted_text?: string | null,
};

export type DeleteMonitorCheckResultInput = {
  id: string,
};

export type CreateChatDataInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  type?: ChatDataType | null,
  file_type?: ResourceType | null,
  text?: string | null,
  file_url?: string | null,
  mentioned_monitor_id_list?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  sort_index: number,
  groups?: string | null,
};

export enum ChatDataType {
  TEXT = "TEXT",
  FILE = "FILE",
  SYSTEMLOG = "SYSTEMLOG",
  TYPING = "TYPING",
  ICON = "ICON",
}


export type ModelChatDataConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  type?: ModelChatDataTypeInput | null,
  file_type?: ModelResourceTypeInput | null,
  text?: ModelStringInput | null,
  file_url?: ModelStringInput | null,
  mentioned_monitor_id_list?: ModelStringInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  and?: Array< ModelChatDataConditionInput | null > | null,
  or?: Array< ModelChatDataConditionInput | null > | null,
  not?: ModelChatDataConditionInput | null,
};

export type ModelChatDataTypeInput = {
  eq?: ChatDataType | null,
  ne?: ChatDataType | null,
};

export type ChatData = {
  __typename: "ChatData",
  id: string,
  subject_id: string,
  interview_id: string,
  type?: ChatDataType | null,
  file_type?: ResourceType | null,
  text?: string | null,
  file_url?: string | null,
  mentioned_monitor_id_list?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  sort_index: number,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateChatDataInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  type?: ChatDataType | null,
  file_type?: ResourceType | null,
  text?: string | null,
  file_url?: string | null,
  mentioned_monitor_id_list?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  sort_index?: number | null,
  groups?: string | null,
};

export type DeleteChatDataInput = {
  id: string,
};

export type CreateUsedResourceInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  type: UsedResourceType,
  key: string,
  groups?: string | null,
};

export enum UsedResourceType {
  SCENARIO = "SCENARIO",
  FILE = "FILE",
}


export type ModelUsedResourceConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  type?: ModelUsedResourceTypeInput | null,
  key?: ModelStringInput | null,
  and?: Array< ModelUsedResourceConditionInput | null > | null,
  or?: Array< ModelUsedResourceConditionInput | null > | null,
  not?: ModelUsedResourceConditionInput | null,
};

export type ModelUsedResourceTypeInput = {
  eq?: UsedResourceType | null,
  ne?: UsedResourceType | null,
};

export type UsedResource = {
  __typename: "UsedResource",
  id: string,
  subject_id: string,
  interview_id: string,
  type: UsedResourceType,
  key: string,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUsedResourceInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  type?: UsedResourceType | null,
  key?: string | null,
  groups?: string | null,
};

export type DeleteUsedResourceInput = {
  id: string,
};

export type CreateMonitorResourceInput = {
  id?: string | null,
  subject_id: string,
  monitor_id: string,
  interview_id: string,
  sort_index: number,
  file_name: string,
  type: ResourceType,
  url: string,
  groups?: string | null,
};

export type ModelMonitorResourceConditionInput = {
  subject_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  file_name?: ModelStringInput | null,
  type?: ModelResourceTypeInput | null,
  url?: ModelStringInput | null,
  and?: Array< ModelMonitorResourceConditionInput | null > | null,
  or?: Array< ModelMonitorResourceConditionInput | null > | null,
  not?: ModelMonitorResourceConditionInput | null,
};

export type MonitorResource = {
  __typename: "MonitorResource",
  id: string,
  subject_id: string,
  monitor_id: string,
  interview_id: string,
  sort_index: number,
  file_name: string,
  type: ResourceType,
  url: string,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMonitorResourceInput = {
  id: string,
  subject_id?: string | null,
  monitor_id?: string | null,
  interview_id?: string | null,
  sort_index?: number | null,
  file_name?: string | null,
  type?: ResourceType | null,
  url?: string | null,
  groups?: string | null,
};

export type DeleteMonitorResourceInput = {
  id: string,
};

export type CreateInterviewResourceInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  sort_index: number,
  chat_data_id?: string | null,
  type: ResourceType,
  title?: string | null,
  description?: string | null,
  file_name: string,
  url: string,
  groups?: string | null,
};

export type ModelInterviewResourceConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  chat_data_id?: ModelIDInput | null,
  type?: ModelResourceTypeInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  file_name?: ModelStringInput | null,
  url?: ModelStringInput | null,
  and?: Array< ModelInterviewResourceConditionInput | null > | null,
  or?: Array< ModelInterviewResourceConditionInput | null > | null,
  not?: ModelInterviewResourceConditionInput | null,
};

export type InterviewResource = {
  __typename: "InterviewResource",
  id: string,
  subject_id: string,
  interview_id: string,
  sort_index: number,
  chat_data_id?: string | null,
  type: ResourceType,
  title?: string | null,
  description?: string | null,
  file_name: string,
  url: string,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateInterviewResourceInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  sort_index?: number | null,
  chat_data_id?: string | null,
  type?: ResourceType | null,
  title?: string | null,
  description?: string | null,
  file_name?: string | null,
  url?: string | null,
  groups?: string | null,
};

export type DeleteInterviewResourceInput = {
  id: string,
};

export type CreateChatTokenInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  moderator_id?: string | null,
  monitor_id?: string | null,
  last_event_dates_id?: string | null,
  last_event_dates_updatedAt?: string | null,
  typing_chat_data_id?: string | null,
  read_index_id?: string | null,
  refreshed_at?: string | null,
  groups?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelChatTokenConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  last_event_dates_id?: ModelIDInput | null,
  last_event_dates_updatedAt?: ModelStringInput | null,
  typing_chat_data_id?: ModelIDInput | null,
  read_index_id?: ModelIDInput | null,
  refreshed_at?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelChatTokenConditionInput | null > | null,
  or?: Array< ModelChatTokenConditionInput | null > | null,
  not?: ModelChatTokenConditionInput | null,
};

export type ChatToken = {
  __typename: "ChatToken",
  id: string,
  subject_id: string,
  interview_id: string,
  moderator_id?: string | null,
  monitor_id?: string | null,
  last_event_dates_id?: string | null,
  last_event_dates_updatedAt?: string | null,
  typing_chat_data_id?: string | null,
  read_index_id?: string | null,
  refreshed_at?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateChatTokenInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  last_event_dates_id?: string | null,
  last_event_dates_updatedAt?: string | null,
  typing_chat_data_id?: string | null,
  read_index_id?: string | null,
  refreshed_at?: string | null,
  groups?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteChatTokenInput = {
  id: string,
};

export type CreateLastEventDatesInput = {
  id?: string | null,
  chat_created?: string | null,
  monitor_typing?: string | null,
  moderator_read?: string | null,
  monitor_read?: string | null,
  interviewer_announce?: string | null,
  chat_token_id: string,
};

export type ModelLastEventDatesConditionInput = {
  chat_created?: ModelStringInput | null,
  monitor_typing?: ModelStringInput | null,
  moderator_read?: ModelStringInput | null,
  monitor_read?: ModelStringInput | null,
  interviewer_announce?: ModelStringInput | null,
  chat_token_id?: ModelIDInput | null,
  and?: Array< ModelLastEventDatesConditionInput | null > | null,
  or?: Array< ModelLastEventDatesConditionInput | null > | null,
  not?: ModelLastEventDatesConditionInput | null,
};

export type LastEventDates = {
  __typename: "LastEventDates",
  id: string,
  chat_created?: string | null,
  monitor_typing?: string | null,
  moderator_read?: string | null,
  monitor_read?: string | null,
  interviewer_announce?: string | null,
  chat_token_id: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLastEventDatesInput = {
  id: string,
  chat_created?: string | null,
  monitor_typing?: string | null,
  moderator_read?: string | null,
  monitor_read?: string | null,
  interviewer_announce?: string | null,
  chat_token_id?: string | null,
};

export type DeleteLastEventDatesInput = {
  id: string,
};

export type CreateLastChatSortIndexInput = {
  id?: string | null,
  interview_id: string,
  chat_sort_index: number,
};

export type ModelLastChatSortIndexConditionInput = {
  interview_id?: ModelIDInput | null,
  chat_sort_index?: ModelIntInput | null,
  and?: Array< ModelLastChatSortIndexConditionInput | null > | null,
  or?: Array< ModelLastChatSortIndexConditionInput | null > | null,
  not?: ModelLastChatSortIndexConditionInput | null,
};

export type LastChatSortIndex = {
  __typename: "LastChatSortIndex",
  id: string,
  interview_id: string,
  chat_sort_index: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLastChatSortIndexInput = {
  id: string,
  interview_id?: string | null,
  chat_sort_index?: number | null,
};

export type DeleteLastChatSortIndexInput = {
  id: string,
};

export type CreateTypingChatDataInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  text?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  groups?: string | null,
};

export type ModelTypingChatDataConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  text?: ModelStringInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  and?: Array< ModelTypingChatDataConditionInput | null > | null,
  or?: Array< ModelTypingChatDataConditionInput | null > | null,
  not?: ModelTypingChatDataConditionInput | null,
};

export type TypingChatData = {
  __typename: "TypingChatData",
  id: string,
  subject_id: string,
  interview_id: string,
  text?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTypingChatDataInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  text?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  groups?: string | null,
};

export type DeleteTypingChatDataInput = {
  id: string,
};

export type CreateReadIndexInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  moderator_id?: string | null,
  monitor_id?: string | null,
  read_index?: number | null,
  groups?: string | null,
};

export type ModelReadIndexConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  read_index?: ModelIntInput | null,
  and?: Array< ModelReadIndexConditionInput | null > | null,
  or?: Array< ModelReadIndexConditionInput | null > | null,
  not?: ModelReadIndexConditionInput | null,
};

export type ReadIndex = {
  __typename: "ReadIndex",
  id: string,
  subject_id: string,
  interview_id: string,
  moderator_id?: string | null,
  monitor_id?: string | null,
  read_index?: number | null,
  groups?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateReadIndexInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  read_index?: number | null,
  groups?: string | null,
};

export type DeleteReadIndexInput = {
  id: string,
};

export type CreateInterviewerAnnounceInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  text?: string | null,
  sort_index: number,
  groups: string,
};

export type ModelInterviewerAnnounceConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  text?: ModelStringInput | null,
  sort_index?: ModelIntInput | null,
  and?: Array< ModelInterviewerAnnounceConditionInput | null > | null,
  or?: Array< ModelInterviewerAnnounceConditionInput | null > | null,
  not?: ModelInterviewerAnnounceConditionInput | null,
};

export type InterviewerAnnounce = {
  __typename: "InterviewerAnnounce",
  id: string,
  subject_id: string,
  interview_id: string,
  text?: string | null,
  sort_index: number,
  groups: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateInterviewerAnnounceInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  text?: string | null,
  sort_index?: number | null,
  groups?: string | null,
};

export type DeleteInterviewerAnnounceInput = {
  id: string,
};

export type CreateNotificationEventInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  sort_index: number,
  groups: string,
  notification_event_type?: NotificationEventType | null,
};

export enum NotificationEventType {
  MENTION = "MENTION",
  ANNOUNCE = "ANNOUNCE",
}


export type ModelNotificationEventConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  notification_event_type?: ModelNotificationEventTypeInput | null,
  and?: Array< ModelNotificationEventConditionInput | null > | null,
  or?: Array< ModelNotificationEventConditionInput | null > | null,
  not?: ModelNotificationEventConditionInput | null,
};

export type ModelNotificationEventTypeInput = {
  eq?: NotificationEventType | null,
  ne?: NotificationEventType | null,
};

export type NotificationEvent = {
  __typename: "NotificationEvent",
  id: string,
  subject_id: string,
  interview_id: string,
  sort_index: number,
  groups: string,
  notification_event_type?: NotificationEventType | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateNotificationEventInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  sort_index?: number | null,
  groups?: string | null,
  notification_event_type?: NotificationEventType | null,
};

export type DeleteNotificationEventInput = {
  id: string,
};

export type CreateMailInput = {
  id?: string | null,
  subject_id: string,
  interview_id: string,
  monitor_id: string,
  heading: string,
  message: string,
  send_status: SendStatus,
  notification_event_id: string,
  sort_index: number,
  groups: string,
};

export enum SendStatus {
  NONE = "NONE",
  SUCCEED = "SUCCEED",
  FAIL = "FAIL",
}


export type ModelMailConditionInput = {
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  monitor_id?: ModelStringInput | null,
  heading?: ModelStringInput | null,
  message?: ModelStringInput | null,
  send_status?: ModelSendStatusInput | null,
  notification_event_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  and?: Array< ModelMailConditionInput | null > | null,
  or?: Array< ModelMailConditionInput | null > | null,
  not?: ModelMailConditionInput | null,
};

export type ModelSendStatusInput = {
  eq?: SendStatus | null,
  ne?: SendStatus | null,
};

export type Mail = {
  __typename: "Mail",
  id: string,
  subject_id: string,
  interview_id: string,
  monitor_id: string,
  heading: string,
  message: string,
  send_status: SendStatus,
  notification_event_id: string,
  sort_index: number,
  groups: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMailInput = {
  id: string,
  subject_id?: string | null,
  interview_id?: string | null,
  monitor_id?: string | null,
  heading?: string | null,
  message?: string | null,
  send_status?: SendStatus | null,
  notification_event_id?: string | null,
  sort_index?: number | null,
  groups?: string | null,
};

export type DeleteMailInput = {
  id: string,
};

export type CreateEmailInput = {
  id?: string | null,
  monitor_id: string,
  subject_id: string,
  email: string,
  groups: string,
};

export type ModelEmailConditionInput = {
  subject_id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  and?: Array< ModelEmailConditionInput | null > | null,
  or?: Array< ModelEmailConditionInput | null > | null,
  not?: ModelEmailConditionInput | null,
};

export type Email = {
  __typename: "Email",
  id: string,
  monitor_id: string,
  subject_id: string,
  email: string,
  groups: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEmailInput = {
  id?: string | null,
  monitor_id: string,
  subject_id?: string | null,
  email?: string | null,
  groups?: string | null,
};

export type DeleteEmailInput = {
  monitor_id: string,
};

export type MonitorAssignLfInput = {
  id?: string | null,
  subject_id?: string | null,
  monitor_id?: string | null,
  interview_id?: string | null,
  pin?: string | null,
  last_entry_date?: string | null,
  groups?: string | null,
};

export type InterviewLfInput = {
  id?: string | null,
  subject_id?: string | null,
  interview_seq?: number | null,
  scheduled_start_date?: string | null,
  scheduled_end_date?: string | null,
  scheduled_start_time?: string | null,
  scheduled_end_time?: string | null,
  actual_start_date?: string | null,
  actual_end_date?: string | null,
  actual_start_time?: string | null,
  actual_end_time?: string | null,
  canceled?: number | null,
  memo?: string | null,
  note?: string | null,
  groups?: string | null,
};

export type ChatDataLfInput = {
  id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  type?: ChatDataType | null,
  file_type?: ResourceType | null,
  text?: string | null,
  file_url?: string | null,
  mentioned_monitor_id_list?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  sort_index?: number | null,
  groups?: string | null,
};

export type UsedResourceLfInput = {
  id?: string | null,
  interview_id?: string | null,
  type?: UsedResourceType | null,
  key?: string | null,
  groups?: string | null,
};

export type MonitorResourceLfInput = {
  id?: string | null,
  subject_id?: string | null,
  monitor_id?: string | null,
  interview_id?: string | null,
  sort_index?: number | null,
  file_name?: string | null,
  type?: ResourceType | null,
  url?: string | null,
  groups?: string | null,
};

export type InterviewResourceLfInput = {
  id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  sort_index?: number | null,
  chat_data_id?: string | null,
  type?: ResourceType | null,
  title?: string | null,
  description?: string | null,
  file_name?: string | null,
  url?: string | null,
  groups?: string | null,
};

export type TypingChatDataLfInput = {
  id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  text?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  groups?: string | null,
};

export type ReadIndexLfInput = {
  id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  moderator_id?: string | null,
  monitor_id?: string | null,
  read_index?: number | null,
  groups?: string | null,
};

export type InterviewerAnnounceLfInput = {
  id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  text?: string | null,
  sort_index?: number | null,
  groups?: string | null,
};

export type MonitorCheckResultLfInput = {
  monitor_id?: string | null,
  subject_id?: string | null,
  interview_id?: string | null,
  initial_name?: string | null,
  initial_sex?: string | null,
  initial_age?: string | null,
  initial_address?: string | null,
  initial_marriage?: string | null,
  initial_children?: string | null,
  initial_job?: string | null,
  monitor_check_result_type?: MonitorCheckResultType | null,
  submitted_text?: string | null,
};

export type ModelGroupFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  memo?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelGroupFilterInput | null > | null,
  or?: Array< ModelGroupFilterInput | null > | null,
  not?: ModelGroupFilterInput | null,
};

export type ModelGroupConnection = {
  __typename: "ModelGroupConnection",
  items:  Array<Group | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  group_id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  role?: ModelConsoleRoleTypeInput | null,
  is_personal_data_handler?: ModelBooleanInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelSubjectFilterInput = {
  id?: ModelIDInput | null,
  group_id?: ModelIDInput | null,
  subject_seq?: ModelIntInput | null,
  subject_number?: ModelStringInput | null,
  subject_name?: ModelStringInput | null,
  subject_description?: ModelStringInput | null,
  subject_purpose?: ModelStringInput | null,
  interview_type?: ModelInterviewTypeInput | null,
  start_date?: ModelStringInput | null,
  end_date?: ModelStringInput | null,
  input_expiration_date?: ModelStringInput | null,
  expiration_date?: ModelStringInput | null,
  main_user_id_group?: ModelIDInput | null,
  main_user_id_asmarq?: ModelIDInput | null,
  memo?: ModelStringInput | null,
  canceled?: ModelIntInput | null,
  finished?: ModelIntInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelSubjectFilterInput | null > | null,
  or?: Array< ModelSubjectFilterInput | null > | null,
  not?: ModelSubjectFilterInput | null,
};

export type ModelSubjectConnection = {
  __typename: "ModelSubjectConnection",
  items:  Array<Subject | null >,
  nextToken?: string | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelMarkedSubjectFilterInput = {
  id?: ModelIDInput | null,
  user_id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelMarkedSubjectFilterInput | null > | null,
  or?: Array< ModelMarkedSubjectFilterInput | null > | null,
  not?: ModelMarkedSubjectFilterInput | null,
};

export type ModelMarkedSubjectConnection = {
  __typename: "ModelMarkedSubjectConnection",
  items:  Array<MarkedSubject | null >,
  nextToken?: string | null,
};

export type ModelInterviewFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_seq?: ModelIntInput | null,
  interview_type?: ModelInterviewTypeInput | null,
  scheduled_start_date?: ModelStringInput | null,
  scheduled_end_date?: ModelStringInput | null,
  scheduled_start_time?: ModelStringInput | null,
  scheduled_end_time?: ModelStringInput | null,
  actual_start_date?: ModelStringInput | null,
  actual_end_date?: ModelStringInput | null,
  actual_start_time?: ModelStringInput | null,
  actual_end_time?: ModelStringInput | null,
  canceled?: ModelIntInput | null,
  memo?: ModelStringInput | null,
  note?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelInterviewFilterInput | null > | null,
  or?: Array< ModelInterviewFilterInput | null > | null,
  not?: ModelInterviewFilterInput | null,
};

export type ModelInterviewConnection = {
  __typename: "ModelInterviewConnection",
  items:  Array<Interview | null >,
  nextToken?: string | null,
};

export type ModelFileResourceFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  file_name?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelResourceTypeInput | null,
  url?: ModelStringInput | null,
  description?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelFileResourceFilterInput | null > | null,
  or?: Array< ModelFileResourceFilterInput | null > | null,
  not?: ModelFileResourceFilterInput | null,
};

export type ModelFileResourceConnection = {
  __typename: "ModelFileResourceConnection",
  items:  Array<FileResource | null >,
  nextToken?: string | null,
};

export type ModelScenarioFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  scenario_no?: ModelIntInput | null,
  template_no?: ModelIntInput | null,
  text?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelScenarioFilterInput | null > | null,
  or?: Array< ModelScenarioFilterInput | null > | null,
  not?: ModelScenarioFilterInput | null,
};

export type ModelScenarioConnection = {
  __typename: "ModelScenarioConnection",
  items:  Array<Scenario | null >,
  nextToken?: string | null,
};

export type ModelMonitorFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  ans_id?: ModelStringInput | null,
  classification?: ModelStringInput | null,
  member_id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  sex?: ModelStringInput | null,
  age?: ModelStringInput | null,
  address?: ModelStringInput | null,
  marriage?: ModelStringInput | null,
  children?: ModelStringInput | null,
  job?: ModelStringInput | null,
  memo?: ModelStringInput | null,
  sort_index?: ModelIntInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelMonitorFilterInput | null > | null,
  or?: Array< ModelMonitorFilterInput | null > | null,
  not?: ModelMonitorFilterInput | null,
};

export type ModelMonitorConnection = {
  __typename: "ModelMonitorConnection",
  items:  Array<Monitor | null >,
  nextToken?: string | null,
};

export type ModelMonitorAssignFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  pin?: ModelStringInput | null,
  last_entry_date?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelMonitorAssignFilterInput | null > | null,
  or?: Array< ModelMonitorAssignFilterInput | null > | null,
  not?: ModelMonitorAssignFilterInput | null,
};

export type ModelMonitorAssignConnection = {
  __typename: "ModelMonitorAssignConnection",
  items:  Array<MonitorAssign | null >,
  nextToken?: string | null,
};

export type ModelMonitorAttributeFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  seq_no?: ModelIntInput | null,
  name?: ModelStringInput | null,
  value?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelMonitorAttributeFilterInput | null > | null,
  or?: Array< ModelMonitorAttributeFilterInput | null > | null,
  not?: ModelMonitorAttributeFilterInput | null,
};

export type ModelMonitorAttributeConnection = {
  __typename: "ModelMonitorAttributeConnection",
  items:  Array<MonitorAttribute | null >,
  nextToken?: string | null,
};

export type ModelMonitorCheckResultFilterInput = {
  monitor_id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  initial_name?: ModelStringInput | null,
  initial_sex?: ModelStringInput | null,
  initial_age?: ModelStringInput | null,
  initial_address?: ModelStringInput | null,
  initial_marriage?: ModelStringInput | null,
  initial_children?: ModelStringInput | null,
  initial_job?: ModelStringInput | null,
  monitor_check_result_type?: ModelMonitorCheckResultTypeInput | null,
  submitted_text?: ModelStringInput | null,
  and?: Array< ModelMonitorCheckResultFilterInput | null > | null,
  or?: Array< ModelMonitorCheckResultFilterInput | null > | null,
  not?: ModelMonitorCheckResultFilterInput | null,
};

export type ModelMonitorCheckResultConnection = {
  __typename: "ModelMonitorCheckResultConnection",
  items:  Array<MonitorCheckResult | null >,
  nextToken?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelChatDataFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  type?: ModelChatDataTypeInput | null,
  file_type?: ModelResourceTypeInput | null,
  text?: ModelStringInput | null,
  file_url?: ModelStringInput | null,
  mentioned_monitor_id_list?: ModelStringInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelChatDataFilterInput | null > | null,
  or?: Array< ModelChatDataFilterInput | null > | null,
  not?: ModelChatDataFilterInput | null,
};

export type ModelChatDataConnection = {
  __typename: "ModelChatDataConnection",
  items:  Array<ChatData | null >,
  nextToken?: string | null,
};

export type ModelUsedResourceFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  type?: ModelUsedResourceTypeInput | null,
  key?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelUsedResourceFilterInput | null > | null,
  or?: Array< ModelUsedResourceFilterInput | null > | null,
  not?: ModelUsedResourceFilterInput | null,
};

export type ModelUsedResourceConnection = {
  __typename: "ModelUsedResourceConnection",
  items:  Array<UsedResource | null >,
  nextToken?: string | null,
};

export type ModelMonitorResourceFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  file_name?: ModelStringInput | null,
  type?: ModelResourceTypeInput | null,
  url?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelMonitorResourceFilterInput | null > | null,
  or?: Array< ModelMonitorResourceFilterInput | null > | null,
  not?: ModelMonitorResourceFilterInput | null,
};

export type ModelMonitorResourceConnection = {
  __typename: "ModelMonitorResourceConnection",
  items:  Array<MonitorResource | null >,
  nextToken?: string | null,
};

export type ModelInterviewResourceFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  chat_data_id?: ModelIDInput | null,
  type?: ModelResourceTypeInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  file_name?: ModelStringInput | null,
  url?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelInterviewResourceFilterInput | null > | null,
  or?: Array< ModelInterviewResourceFilterInput | null > | null,
  not?: ModelInterviewResourceFilterInput | null,
};

export type ModelInterviewResourceConnection = {
  __typename: "ModelInterviewResourceConnection",
  items:  Array<InterviewResource | null >,
  nextToken?: string | null,
};

export type ModelChatTokenFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  last_event_dates_id?: ModelIDInput | null,
  last_event_dates_updatedAt?: ModelStringInput | null,
  typing_chat_data_id?: ModelIDInput | null,
  read_index_id?: ModelIDInput | null,
  refreshed_at?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelChatTokenFilterInput | null > | null,
  or?: Array< ModelChatTokenFilterInput | null > | null,
  not?: ModelChatTokenFilterInput | null,
};

export type ModelChatTokenConnection = {
  __typename: "ModelChatTokenConnection",
  items:  Array<ChatToken | null >,
  nextToken?: string | null,
};

export type ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyConditionInput = {
  eq?: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput | null,
  le?: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput | null,
  lt?: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput | null,
  ge?: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput | null,
  gt?: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput | null,
  between?: Array< ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput | null > | null,
  beginsWith?: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput | null,
};

export type ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyInput = {
  interview_id?: string | null,
  createdAt?: string | null,
};

export type ModelLastEventDatesFilterInput = {
  id?: ModelIDInput | null,
  chat_created?: ModelStringInput | null,
  monitor_typing?: ModelStringInput | null,
  moderator_read?: ModelStringInput | null,
  monitor_read?: ModelStringInput | null,
  interviewer_announce?: ModelStringInput | null,
  chat_token_id?: ModelIDInput | null,
  and?: Array< ModelLastEventDatesFilterInput | null > | null,
  or?: Array< ModelLastEventDatesFilterInput | null > | null,
  not?: ModelLastEventDatesFilterInput | null,
};

export type ModelLastEventDatesConnection = {
  __typename: "ModelLastEventDatesConnection",
  items:  Array<LastEventDates | null >,
  nextToken?: string | null,
};

export type ModelLastChatSortIndexFilterInput = {
  id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  chat_sort_index?: ModelIntInput | null,
  and?: Array< ModelLastChatSortIndexFilterInput | null > | null,
  or?: Array< ModelLastChatSortIndexFilterInput | null > | null,
  not?: ModelLastChatSortIndexFilterInput | null,
};

export type ModelLastChatSortIndexConnection = {
  __typename: "ModelLastChatSortIndexConnection",
  items:  Array<LastChatSortIndex | null >,
  nextToken?: string | null,
};

export type ModelTypingChatDataFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  text?: ModelStringInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelTypingChatDataFilterInput | null > | null,
  or?: Array< ModelTypingChatDataFilterInput | null > | null,
  not?: ModelTypingChatDataFilterInput | null,
};

export type ModelTypingChatDataConnection = {
  __typename: "ModelTypingChatDataConnection",
  items:  Array<TypingChatData | null >,
  nextToken?: string | null,
};

export type ModelReadIndexFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  moderator_id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  read_index?: ModelIntInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelReadIndexFilterInput | null > | null,
  or?: Array< ModelReadIndexFilterInput | null > | null,
  not?: ModelReadIndexFilterInput | null,
};

export type ModelReadIndexConnection = {
  __typename: "ModelReadIndexConnection",
  items:  Array<ReadIndex | null >,
  nextToken?: string | null,
};

export type ModelInterviewerAnnounceFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  text?: ModelStringInput | null,
  sort_index?: ModelIntInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelInterviewerAnnounceFilterInput | null > | null,
  or?: Array< ModelInterviewerAnnounceFilterInput | null > | null,
  not?: ModelInterviewerAnnounceFilterInput | null,
};

export type ModelInterviewerAnnounceConnection = {
  __typename: "ModelInterviewerAnnounceConnection",
  items:  Array<InterviewerAnnounce | null >,
  nextToken?: string | null,
};

export type ModelNotificationEventFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  groups?: ModelStringInput | null,
  notification_event_type?: ModelNotificationEventTypeInput | null,
  and?: Array< ModelNotificationEventFilterInput | null > | null,
  or?: Array< ModelNotificationEventFilterInput | null > | null,
  not?: ModelNotificationEventFilterInput | null,
};

export type ModelNotificationEventConnection = {
  __typename: "ModelNotificationEventConnection",
  items:  Array<NotificationEvent | null >,
  nextToken?: string | null,
};

export type ModelMailFilterInput = {
  id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  interview_id?: ModelIDInput | null,
  monitor_id?: ModelStringInput | null,
  heading?: ModelStringInput | null,
  message?: ModelStringInput | null,
  send_status?: ModelSendStatusInput | null,
  notification_event_id?: ModelIDInput | null,
  sort_index?: ModelIntInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelMailFilterInput | null > | null,
  or?: Array< ModelMailFilterInput | null > | null,
  not?: ModelMailFilterInput | null,
};

export type ModelMailConnection = {
  __typename: "ModelMailConnection",
  items:  Array<Mail | null >,
  nextToken?: string | null,
};

export type ModelEmailFilterInput = {
  id?: ModelIDInput | null,
  monitor_id?: ModelIDInput | null,
  subject_id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelEmailFilterInput | null > | null,
  or?: Array< ModelEmailFilterInput | null > | null,
  not?: ModelEmailFilterInput | null,
};

export type ModelEmailConnection = {
  __typename: "ModelEmailConnection",
  items:  Array<Email | null >,
  nextToken?: string | null,
};

export type CreateGroupLfMutationVariables = {
  input?: GroupLfInput | null,
  id?: string | null,
};

export type CreateGroupLfMutation = {
  createGroupLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type UpdateGroupLfMutationVariables = {
  input?: GroupLfInput | null,
  id?: string | null,
};

export type UpdateGroupLfMutation = {
  updateGroupLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type DeleteGroupLfMutationVariables = {
  input?: GroupLfInput | null,
  id?: string | null,
};

export type DeleteGroupLfMutation = {
  deleteGroupLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateUserLfMutationVariables = {
  input?: UserLfInput | null,
  id?: string | null,
};

export type CreateUserLfMutation = {
  createUserLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type UpdateUserLfMutationVariables = {
  input?: UserLfInput | null,
  id?: string | null,
};

export type UpdateUserLfMutation = {
  updateUserLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type DeleteUserLfMutationVariables = {
  input?: UserLfInput | null,
  id?: string | null,
};

export type DeleteUserLfMutation = {
  deleteUserLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateModeratorChatTokenLfMutationVariables = {
  input?: ChatTokenLfInput | null,
};

export type CreateModeratorChatTokenLfMutation = {
  createModeratorChatTokenLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateGroupMutationVariables = {
  input: CreateGroupInput,
  condition?: ModelGroupConditionInput | null,
};

export type CreateGroupMutation = {
  createGroup?:  {
    __typename: "Group",
    id: string,
    name: string,
    memo?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateGroupMutationVariables = {
  input: UpdateGroupInput,
  condition?: ModelGroupConditionInput | null,
};

export type UpdateGroupMutation = {
  updateGroup?:  {
    __typename: "Group",
    id: string,
    name: string,
    memo?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteGroupMutationVariables = {
  input: DeleteGroupInput,
  condition?: ModelGroupConditionInput | null,
};

export type DeleteGroupMutation = {
  deleteGroup?:  {
    __typename: "Group",
    id: string,
    name: string,
    memo?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    group_id: string,
    name: string,
    email: string,
    role: ConsoleRoleType,
    is_personal_data_handler?: boolean | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    group_id: string,
    name: string,
    email: string,
    role: ConsoleRoleType,
    is_personal_data_handler?: boolean | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    group_id: string,
    name: string,
    email: string,
    role: ConsoleRoleType,
    is_personal_data_handler?: boolean | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSubjectMutationVariables = {
  input: CreateSubjectInput,
  condition?: ModelSubjectConditionInput | null,
};

export type CreateSubjectMutation = {
  createSubject?:  {
    __typename: "Subject",
    id: string,
    group_id: string,
    subject_seq: number,
    subject_number: string,
    subject_name?: string | null,
    subject_description?: string | null,
    subject_purpose?: string | null,
    interview_type?: InterviewType | null,
    start_date?: string | null,
    end_date?: string | null,
    input_expiration_date?: string | null,
    expiration_date?: string | null,
    main_user_id_group?: string | null,
    main_user_id_asmarq?: string | null,
    memo?: string | null,
    canceled: number,
    finished?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSubjectMutationVariables = {
  input: UpdateSubjectInput,
  condition?: ModelSubjectConditionInput | null,
};

export type UpdateSubjectMutation = {
  updateSubject?:  {
    __typename: "Subject",
    id: string,
    group_id: string,
    subject_seq: number,
    subject_number: string,
    subject_name?: string | null,
    subject_description?: string | null,
    subject_purpose?: string | null,
    interview_type?: InterviewType | null,
    start_date?: string | null,
    end_date?: string | null,
    input_expiration_date?: string | null,
    expiration_date?: string | null,
    main_user_id_group?: string | null,
    main_user_id_asmarq?: string | null,
    memo?: string | null,
    canceled: number,
    finished?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSubjectMutationVariables = {
  input: DeleteSubjectInput,
  condition?: ModelSubjectConditionInput | null,
};

export type DeleteSubjectMutation = {
  deleteSubject?:  {
    __typename: "Subject",
    id: string,
    group_id: string,
    subject_seq: number,
    subject_number: string,
    subject_name?: string | null,
    subject_description?: string | null,
    subject_purpose?: string | null,
    interview_type?: InterviewType | null,
    start_date?: string | null,
    end_date?: string | null,
    input_expiration_date?: string | null,
    expiration_date?: string | null,
    main_user_id_group?: string | null,
    main_user_id_asmarq?: string | null,
    memo?: string | null,
    canceled: number,
    finished?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMarkedSubjectMutationVariables = {
  input: CreateMarkedSubjectInput,
  condition?: ModelMarkedSubjectConditionInput | null,
};

export type CreateMarkedSubjectMutation = {
  createMarkedSubject?:  {
    __typename: "MarkedSubject",
    id: string,
    user_id: string,
    subject_id: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMarkedSubjectMutationVariables = {
  input: UpdateMarkedSubjectInput,
  condition?: ModelMarkedSubjectConditionInput | null,
};

export type UpdateMarkedSubjectMutation = {
  updateMarkedSubject?:  {
    __typename: "MarkedSubject",
    id: string,
    user_id: string,
    subject_id: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMarkedSubjectMutationVariables = {
  input: DeleteMarkedSubjectInput,
  condition?: ModelMarkedSubjectConditionInput | null,
};

export type DeleteMarkedSubjectMutation = {
  deleteMarkedSubject?:  {
    __typename: "MarkedSubject",
    id: string,
    user_id: string,
    subject_id: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInterviewMutationVariables = {
  input: CreateInterviewInput,
  condition?: ModelInterviewConditionInput | null,
};

export type CreateInterviewMutation = {
  createInterview?:  {
    __typename: "Interview",
    id: string,
    subject_id: string,
    interview_seq: number,
    interview_type?: InterviewType | null,
    scheduled_start_date?: string | null,
    scheduled_end_date?: string | null,
    scheduled_start_time?: string | null,
    scheduled_end_time?: string | null,
    actual_start_date?: string | null,
    actual_end_date?: string | null,
    actual_start_time?: string | null,
    actual_end_time?: string | null,
    canceled: number,
    memo?: string | null,
    note?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateInterviewMutationVariables = {
  input: UpdateInterviewInput,
  condition?: ModelInterviewConditionInput | null,
};

export type UpdateInterviewMutation = {
  updateInterview?:  {
    __typename: "Interview",
    id: string,
    subject_id: string,
    interview_seq: number,
    interview_type?: InterviewType | null,
    scheduled_start_date?: string | null,
    scheduled_end_date?: string | null,
    scheduled_start_time?: string | null,
    scheduled_end_time?: string | null,
    actual_start_date?: string | null,
    actual_end_date?: string | null,
    actual_start_time?: string | null,
    actual_end_time?: string | null,
    canceled: number,
    memo?: string | null,
    note?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteInterviewMutationVariables = {
  input: DeleteInterviewInput,
  condition?: ModelInterviewConditionInput | null,
};

export type DeleteInterviewMutation = {
  deleteInterview?:  {
    __typename: "Interview",
    id: string,
    subject_id: string,
    interview_seq: number,
    interview_type?: InterviewType | null,
    scheduled_start_date?: string | null,
    scheduled_end_date?: string | null,
    scheduled_start_time?: string | null,
    scheduled_end_time?: string | null,
    actual_start_date?: string | null,
    actual_end_date?: string | null,
    actual_start_time?: string | null,
    actual_end_time?: string | null,
    canceled: number,
    memo?: string | null,
    note?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFileResourceMutationVariables = {
  input: CreateFileResourceInput,
  condition?: ModelFileResourceConditionInput | null,
};

export type CreateFileResourceMutation = {
  createFileResource?:  {
    __typename: "FileResource",
    id: string,
    subject_id: string,
    sort_index: number,
    file_name: string,
    title: string,
    type: ResourceType,
    url: string,
    description?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFileResourceMutationVariables = {
  input: UpdateFileResourceInput,
  condition?: ModelFileResourceConditionInput | null,
};

export type UpdateFileResourceMutation = {
  updateFileResource?:  {
    __typename: "FileResource",
    id: string,
    subject_id: string,
    sort_index: number,
    file_name: string,
    title: string,
    type: ResourceType,
    url: string,
    description?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFileResourceMutationVariables = {
  input: DeleteFileResourceInput,
  condition?: ModelFileResourceConditionInput | null,
};

export type DeleteFileResourceMutation = {
  deleteFileResource?:  {
    __typename: "FileResource",
    id: string,
    subject_id: string,
    sort_index: number,
    file_name: string,
    title: string,
    type: ResourceType,
    url: string,
    description?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateScenarioMutationVariables = {
  input: CreateScenarioInput,
  condition?: ModelScenarioConditionInput | null,
};

export type CreateScenarioMutation = {
  createScenario?:  {
    __typename: "Scenario",
    id: string,
    subject_id: string,
    sort_index: number,
    scenario_no: number,
    template_no: number,
    text?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateScenarioMutationVariables = {
  input: UpdateScenarioInput,
  condition?: ModelScenarioConditionInput | null,
};

export type UpdateScenarioMutation = {
  updateScenario?:  {
    __typename: "Scenario",
    id: string,
    subject_id: string,
    sort_index: number,
    scenario_no: number,
    template_no: number,
    text?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteScenarioMutationVariables = {
  input: DeleteScenarioInput,
  condition?: ModelScenarioConditionInput | null,
};

export type DeleteScenarioMutation = {
  deleteScenario?:  {
    __typename: "Scenario",
    id: string,
    subject_id: string,
    sort_index: number,
    scenario_no: number,
    template_no: number,
    text?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMonitorMutationVariables = {
  input: CreateMonitorInput,
  condition?: ModelMonitorConditionInput | null,
};

export type CreateMonitorMutation = {
  createMonitor?:  {
    __typename: "Monitor",
    id: string,
    subject_id: string,
    ans_id: string,
    classification?: string | null,
    member_id?: string | null,
    name?: string | null,
    sex?: string | null,
    age?: string | null,
    address?: string | null,
    marriage?: string | null,
    children?: string | null,
    job?: string | null,
    memo?: string | null,
    sort_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMonitorMutationVariables = {
  input: UpdateMonitorInput,
  condition?: ModelMonitorConditionInput | null,
};

export type UpdateMonitorMutation = {
  updateMonitor?:  {
    __typename: "Monitor",
    id: string,
    subject_id: string,
    ans_id: string,
    classification?: string | null,
    member_id?: string | null,
    name?: string | null,
    sex?: string | null,
    age?: string | null,
    address?: string | null,
    marriage?: string | null,
    children?: string | null,
    job?: string | null,
    memo?: string | null,
    sort_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMonitorMutationVariables = {
  input: DeleteMonitorInput,
  condition?: ModelMonitorConditionInput | null,
};

export type DeleteMonitorMutation = {
  deleteMonitor?:  {
    __typename: "Monitor",
    id: string,
    subject_id: string,
    ans_id: string,
    classification?: string | null,
    member_id?: string | null,
    name?: string | null,
    sex?: string | null,
    age?: string | null,
    address?: string | null,
    marriage?: string | null,
    children?: string | null,
    job?: string | null,
    memo?: string | null,
    sort_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMonitorAssignMutationVariables = {
  input: CreateMonitorAssignInput,
  condition?: ModelMonitorAssignConditionInput | null,
};

export type CreateMonitorAssignMutation = {
  createMonitorAssign?:  {
    __typename: "MonitorAssign",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    pin?: string | null,
    last_entry_date?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMonitorAssignMutationVariables = {
  input: UpdateMonitorAssignInput,
  condition?: ModelMonitorAssignConditionInput | null,
};

export type UpdateMonitorAssignMutation = {
  updateMonitorAssign?:  {
    __typename: "MonitorAssign",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    pin?: string | null,
    last_entry_date?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMonitorAssignMutationVariables = {
  input: DeleteMonitorAssignInput,
  condition?: ModelMonitorAssignConditionInput | null,
};

export type DeleteMonitorAssignMutation = {
  deleteMonitorAssign?:  {
    __typename: "MonitorAssign",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    pin?: string | null,
    last_entry_date?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMonitorAttributeMutationVariables = {
  input: CreateMonitorAttributeInput,
  condition?: ModelMonitorAttributeConditionInput | null,
};

export type CreateMonitorAttributeMutation = {
  createMonitorAttribute?:  {
    __typename: "MonitorAttribute",
    id: string,
    subject_id: string,
    monitor_id: string,
    seq_no: number,
    name: string,
    value?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMonitorAttributeMutationVariables = {
  input: UpdateMonitorAttributeInput,
  condition?: ModelMonitorAttributeConditionInput | null,
};

export type UpdateMonitorAttributeMutation = {
  updateMonitorAttribute?:  {
    __typename: "MonitorAttribute",
    id: string,
    subject_id: string,
    monitor_id: string,
    seq_no: number,
    name: string,
    value?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMonitorAttributeMutationVariables = {
  input: DeleteMonitorAttributeInput,
  condition?: ModelMonitorAttributeConditionInput | null,
};

export type DeleteMonitorAttributeMutation = {
  deleteMonitorAttribute?:  {
    __typename: "MonitorAttribute",
    id: string,
    subject_id: string,
    monitor_id: string,
    seq_no: number,
    name: string,
    value?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMonitorCheckResultMutationVariables = {
  input: CreateMonitorCheckResultInput,
  condition?: ModelMonitorCheckResultConditionInput | null,
};

export type CreateMonitorCheckResultMutation = {
  createMonitorCheckResult?:  {
    __typename: "MonitorCheckResult",
    id: string,
    monitor_id: string,
    subject_id: string,
    interview_id: string,
    initial_name?: string | null,
    initial_sex?: string | null,
    initial_age?: string | null,
    initial_address?: string | null,
    initial_marriage?: string | null,
    initial_children?: string | null,
    initial_job?: string | null,
    monitor_check_result_type?: MonitorCheckResultType | null,
    submitted_text?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMonitorCheckResultMutationVariables = {
  input: UpdateMonitorCheckResultInput,
  condition?: ModelMonitorCheckResultConditionInput | null,
};

export type UpdateMonitorCheckResultMutation = {
  updateMonitorCheckResult?:  {
    __typename: "MonitorCheckResult",
    id: string,
    monitor_id: string,
    subject_id: string,
    interview_id: string,
    initial_name?: string | null,
    initial_sex?: string | null,
    initial_age?: string | null,
    initial_address?: string | null,
    initial_marriage?: string | null,
    initial_children?: string | null,
    initial_job?: string | null,
    monitor_check_result_type?: MonitorCheckResultType | null,
    submitted_text?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMonitorCheckResultMutationVariables = {
  input: DeleteMonitorCheckResultInput,
  condition?: ModelMonitorCheckResultConditionInput | null,
};

export type DeleteMonitorCheckResultMutation = {
  deleteMonitorCheckResult?:  {
    __typename: "MonitorCheckResult",
    id: string,
    monitor_id: string,
    subject_id: string,
    interview_id: string,
    initial_name?: string | null,
    initial_sex?: string | null,
    initial_age?: string | null,
    initial_address?: string | null,
    initial_marriage?: string | null,
    initial_children?: string | null,
    initial_job?: string | null,
    monitor_check_result_type?: MonitorCheckResultType | null,
    submitted_text?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateChatDataMutationVariables = {
  input: CreateChatDataInput,
  condition?: ModelChatDataConditionInput | null,
};

export type CreateChatDataMutation = {
  createChatData?:  {
    __typename: "ChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    type?: ChatDataType | null,
    file_type?: ResourceType | null,
    text?: string | null,
    file_url?: string | null,
    mentioned_monitor_id_list?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    sort_index: number,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateChatDataMutationVariables = {
  input: UpdateChatDataInput,
  condition?: ModelChatDataConditionInput | null,
};

export type UpdateChatDataMutation = {
  updateChatData?:  {
    __typename: "ChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    type?: ChatDataType | null,
    file_type?: ResourceType | null,
    text?: string | null,
    file_url?: string | null,
    mentioned_monitor_id_list?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    sort_index: number,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteChatDataMutationVariables = {
  input: DeleteChatDataInput,
  condition?: ModelChatDataConditionInput | null,
};

export type DeleteChatDataMutation = {
  deleteChatData?:  {
    __typename: "ChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    type?: ChatDataType | null,
    file_type?: ResourceType | null,
    text?: string | null,
    file_url?: string | null,
    mentioned_monitor_id_list?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    sort_index: number,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUsedResourceMutationVariables = {
  input: CreateUsedResourceInput,
  condition?: ModelUsedResourceConditionInput | null,
};

export type CreateUsedResourceMutation = {
  createUsedResource?:  {
    __typename: "UsedResource",
    id: string,
    subject_id: string,
    interview_id: string,
    type: UsedResourceType,
    key: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUsedResourceMutationVariables = {
  input: UpdateUsedResourceInput,
  condition?: ModelUsedResourceConditionInput | null,
};

export type UpdateUsedResourceMutation = {
  updateUsedResource?:  {
    __typename: "UsedResource",
    id: string,
    subject_id: string,
    interview_id: string,
    type: UsedResourceType,
    key: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUsedResourceMutationVariables = {
  input: DeleteUsedResourceInput,
  condition?: ModelUsedResourceConditionInput | null,
};

export type DeleteUsedResourceMutation = {
  deleteUsedResource?:  {
    __typename: "UsedResource",
    id: string,
    subject_id: string,
    interview_id: string,
    type: UsedResourceType,
    key: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMonitorResourceMutationVariables = {
  input: CreateMonitorResourceInput,
  condition?: ModelMonitorResourceConditionInput | null,
};

export type CreateMonitorResourceMutation = {
  createMonitorResource?:  {
    __typename: "MonitorResource",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    sort_index: number,
    file_name: string,
    type: ResourceType,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMonitorResourceMutationVariables = {
  input: UpdateMonitorResourceInput,
  condition?: ModelMonitorResourceConditionInput | null,
};

export type UpdateMonitorResourceMutation = {
  updateMonitorResource?:  {
    __typename: "MonitorResource",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    sort_index: number,
    file_name: string,
    type: ResourceType,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMonitorResourceMutationVariables = {
  input: DeleteMonitorResourceInput,
  condition?: ModelMonitorResourceConditionInput | null,
};

export type DeleteMonitorResourceMutation = {
  deleteMonitorResource?:  {
    __typename: "MonitorResource",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    sort_index: number,
    file_name: string,
    type: ResourceType,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInterviewResourceMutationVariables = {
  input: CreateInterviewResourceInput,
  condition?: ModelInterviewResourceConditionInput | null,
};

export type CreateInterviewResourceMutation = {
  createInterviewResource?:  {
    __typename: "InterviewResource",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    chat_data_id?: string | null,
    type: ResourceType,
    title?: string | null,
    description?: string | null,
    file_name: string,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateInterviewResourceMutationVariables = {
  input: UpdateInterviewResourceInput,
  condition?: ModelInterviewResourceConditionInput | null,
};

export type UpdateInterviewResourceMutation = {
  updateInterviewResource?:  {
    __typename: "InterviewResource",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    chat_data_id?: string | null,
    type: ResourceType,
    title?: string | null,
    description?: string | null,
    file_name: string,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteInterviewResourceMutationVariables = {
  input: DeleteInterviewResourceInput,
  condition?: ModelInterviewResourceConditionInput | null,
};

export type DeleteInterviewResourceMutation = {
  deleteInterviewResource?:  {
    __typename: "InterviewResource",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    chat_data_id?: string | null,
    type: ResourceType,
    title?: string | null,
    description?: string | null,
    file_name: string,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateChatTokenMutationVariables = {
  input: CreateChatTokenInput,
  condition?: ModelChatTokenConditionInput | null,
};

export type CreateChatTokenMutation = {
  createChatToken?:  {
    __typename: "ChatToken",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    last_event_dates_id?: string | null,
    last_event_dates_updatedAt?: string | null,
    typing_chat_data_id?: string | null,
    read_index_id?: string | null,
    refreshed_at?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateChatTokenMutationVariables = {
  input: UpdateChatTokenInput,
  condition?: ModelChatTokenConditionInput | null,
};

export type UpdateChatTokenMutation = {
  updateChatToken?:  {
    __typename: "ChatToken",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    last_event_dates_id?: string | null,
    last_event_dates_updatedAt?: string | null,
    typing_chat_data_id?: string | null,
    read_index_id?: string | null,
    refreshed_at?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteChatTokenMutationVariables = {
  input: DeleteChatTokenInput,
  condition?: ModelChatTokenConditionInput | null,
};

export type DeleteChatTokenMutation = {
  deleteChatToken?:  {
    __typename: "ChatToken",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    last_event_dates_id?: string | null,
    last_event_dates_updatedAt?: string | null,
    typing_chat_data_id?: string | null,
    read_index_id?: string | null,
    refreshed_at?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLastEventDatesMutationVariables = {
  input: CreateLastEventDatesInput,
  condition?: ModelLastEventDatesConditionInput | null,
};

export type CreateLastEventDatesMutation = {
  createLastEventDates?:  {
    __typename: "LastEventDates",
    id: string,
    chat_created?: string | null,
    monitor_typing?: string | null,
    moderator_read?: string | null,
    monitor_read?: string | null,
    interviewer_announce?: string | null,
    chat_token_id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLastEventDatesMutationVariables = {
  input: UpdateLastEventDatesInput,
  condition?: ModelLastEventDatesConditionInput | null,
};

export type UpdateLastEventDatesMutation = {
  updateLastEventDates?:  {
    __typename: "LastEventDates",
    id: string,
    chat_created?: string | null,
    monitor_typing?: string | null,
    moderator_read?: string | null,
    monitor_read?: string | null,
    interviewer_announce?: string | null,
    chat_token_id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLastEventDatesMutationVariables = {
  input: DeleteLastEventDatesInput,
  condition?: ModelLastEventDatesConditionInput | null,
};

export type DeleteLastEventDatesMutation = {
  deleteLastEventDates?:  {
    __typename: "LastEventDates",
    id: string,
    chat_created?: string | null,
    monitor_typing?: string | null,
    moderator_read?: string | null,
    monitor_read?: string | null,
    interviewer_announce?: string | null,
    chat_token_id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLastChatSortIndexMutationVariables = {
  input: CreateLastChatSortIndexInput,
  condition?: ModelLastChatSortIndexConditionInput | null,
};

export type CreateLastChatSortIndexMutation = {
  createLastChatSortIndex?:  {
    __typename: "LastChatSortIndex",
    id: string,
    interview_id: string,
    chat_sort_index: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLastChatSortIndexMutationVariables = {
  input: UpdateLastChatSortIndexInput,
  condition?: ModelLastChatSortIndexConditionInput | null,
};

export type UpdateLastChatSortIndexMutation = {
  updateLastChatSortIndex?:  {
    __typename: "LastChatSortIndex",
    id: string,
    interview_id: string,
    chat_sort_index: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLastChatSortIndexMutationVariables = {
  input: DeleteLastChatSortIndexInput,
  condition?: ModelLastChatSortIndexConditionInput | null,
};

export type DeleteLastChatSortIndexMutation = {
  deleteLastChatSortIndex?:  {
    __typename: "LastChatSortIndex",
    id: string,
    interview_id: string,
    chat_sort_index: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTypingChatDataMutationVariables = {
  input: CreateTypingChatDataInput,
  condition?: ModelTypingChatDataConditionInput | null,
};

export type CreateTypingChatDataMutation = {
  createTypingChatData?:  {
    __typename: "TypingChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTypingChatDataMutationVariables = {
  input: UpdateTypingChatDataInput,
  condition?: ModelTypingChatDataConditionInput | null,
};

export type UpdateTypingChatDataMutation = {
  updateTypingChatData?:  {
    __typename: "TypingChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTypingChatDataMutationVariables = {
  input: DeleteTypingChatDataInput,
  condition?: ModelTypingChatDataConditionInput | null,
};

export type DeleteTypingChatDataMutation = {
  deleteTypingChatData?:  {
    __typename: "TypingChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReadIndexMutationVariables = {
  input: CreateReadIndexInput,
  condition?: ModelReadIndexConditionInput | null,
};

export type CreateReadIndexMutation = {
  createReadIndex?:  {
    __typename: "ReadIndex",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    read_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReadIndexMutationVariables = {
  input: UpdateReadIndexInput,
  condition?: ModelReadIndexConditionInput | null,
};

export type UpdateReadIndexMutation = {
  updateReadIndex?:  {
    __typename: "ReadIndex",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    read_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReadIndexMutationVariables = {
  input: DeleteReadIndexInput,
  condition?: ModelReadIndexConditionInput | null,
};

export type DeleteReadIndexMutation = {
  deleteReadIndex?:  {
    __typename: "ReadIndex",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    read_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInterviewerAnnounceMutationVariables = {
  input: CreateInterviewerAnnounceInput,
  condition?: ModelInterviewerAnnounceConditionInput | null,
};

export type CreateInterviewerAnnounceMutation = {
  createInterviewerAnnounce?:  {
    __typename: "InterviewerAnnounce",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateInterviewerAnnounceMutationVariables = {
  input: UpdateInterviewerAnnounceInput,
  condition?: ModelInterviewerAnnounceConditionInput | null,
};

export type UpdateInterviewerAnnounceMutation = {
  updateInterviewerAnnounce?:  {
    __typename: "InterviewerAnnounce",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteInterviewerAnnounceMutationVariables = {
  input: DeleteInterviewerAnnounceInput,
  condition?: ModelInterviewerAnnounceConditionInput | null,
};

export type DeleteInterviewerAnnounceMutation = {
  deleteInterviewerAnnounce?:  {
    __typename: "InterviewerAnnounce",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNotificationEventMutationVariables = {
  input: CreateNotificationEventInput,
  condition?: ModelNotificationEventConditionInput | null,
};

export type CreateNotificationEventMutation = {
  createNotificationEvent?:  {
    __typename: "NotificationEvent",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    groups: string,
    notification_event_type?: NotificationEventType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateNotificationEventMutationVariables = {
  input: UpdateNotificationEventInput,
  condition?: ModelNotificationEventConditionInput | null,
};

export type UpdateNotificationEventMutation = {
  updateNotificationEvent?:  {
    __typename: "NotificationEvent",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    groups: string,
    notification_event_type?: NotificationEventType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteNotificationEventMutationVariables = {
  input: DeleteNotificationEventInput,
  condition?: ModelNotificationEventConditionInput | null,
};

export type DeleteNotificationEventMutation = {
  deleteNotificationEvent?:  {
    __typename: "NotificationEvent",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    groups: string,
    notification_event_type?: NotificationEventType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMailMutationVariables = {
  input: CreateMailInput,
  condition?: ModelMailConditionInput | null,
};

export type CreateMailMutation = {
  createMail?:  {
    __typename: "Mail",
    id: string,
    subject_id: string,
    interview_id: string,
    monitor_id: string,
    heading: string,
    message: string,
    send_status: SendStatus,
    notification_event_id: string,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMailMutationVariables = {
  input: UpdateMailInput,
  condition?: ModelMailConditionInput | null,
};

export type UpdateMailMutation = {
  updateMail?:  {
    __typename: "Mail",
    id: string,
    subject_id: string,
    interview_id: string,
    monitor_id: string,
    heading: string,
    message: string,
    send_status: SendStatus,
    notification_event_id: string,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMailMutationVariables = {
  input: DeleteMailInput,
  condition?: ModelMailConditionInput | null,
};

export type DeleteMailMutation = {
  deleteMail?:  {
    __typename: "Mail",
    id: string,
    subject_id: string,
    interview_id: string,
    monitor_id: string,
    heading: string,
    message: string,
    send_status: SendStatus,
    notification_event_id: string,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEmailMutationVariables = {
  input: CreateEmailInput,
  condition?: ModelEmailConditionInput | null,
};

export type CreateEmailMutation = {
  createEmail?:  {
    __typename: "Email",
    id: string,
    monitor_id: string,
    subject_id: string,
    email: string,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEmailMutationVariables = {
  input: UpdateEmailInput,
  condition?: ModelEmailConditionInput | null,
};

export type UpdateEmailMutation = {
  updateEmail?:  {
    __typename: "Email",
    id: string,
    monitor_id: string,
    subject_id: string,
    email: string,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEmailMutationVariables = {
  input: DeleteEmailInput,
  condition?: ModelEmailConditionInput | null,
};

export type DeleteEmailMutation = {
  deleteEmail?:  {
    __typename: "Email",
    id: string,
    monitor_id: string,
    subject_id: string,
    email: string,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMonitorChatTokenLfMutationVariables = {
  monitor_assign_id: string,
};

export type CreateMonitorChatTokenLfMutation = {
  createMonitorChatTokenLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type UpdateMonitorAssignLfMutationVariables = {
  input?: MonitorAssignLfInput | null,
};

export type UpdateMonitorAssignLfMutation = {
  updateMonitorAssignLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type UpdateInterviewLfMutationVariables = {
  chat_token_id: string,
  input?: InterviewLfInput | null,
};

export type UpdateInterviewLfMutation = {
  updateInterviewLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateChatDataLfMutationVariables = {
  input?: ChatDataLfInput | null,
  chat_token_id: string,
};

export type CreateChatDataLfMutation = {
  createChatDataLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateUsedResourceLfMutationVariables = {
  input?: UsedResourceLfInput | null,
  chat_token_id: string,
};

export type CreateUsedResourceLfMutation = {
  createUsedResourceLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateMonitorResourceLfMutationVariables = {
  input?: MonitorResourceLfInput | null,
  tmp_key: string,
  chat_token_id: string,
};

export type CreateMonitorResourceLfMutation = {
  createMonitorResourceLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateInterviewResourceLfMutationVariables = {
  input?: InterviewResourceLfInput | null,
  tmp_key: string,
  chat_token_id: string,
};

export type CreateInterviewResourceLfMutation = {
  createInterviewResourceLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type UpdateTypingChatDataLfMutationVariables = {
  chat_token_id: string,
  input?: TypingChatDataLfInput | null,
};

export type UpdateTypingChatDataLfMutation = {
  updateTypingChatDataLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type UpdateReadIndexLfMutationVariables = {
  chat_token_id: string,
  input?: ReadIndexLfInput | null,
};

export type UpdateReadIndexLfMutation = {
  updateReadIndexLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateInterviewerAnnounceLfMutationVariables = {
  input?: InterviewerAnnounceLfInput | null,
  chat_token_id: string,
  is_checked?: boolean | null,
};

export type CreateInterviewerAnnounceLfMutation = {
  createInterviewerAnnounceLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type CreateMonitorCheckResultLfMutationVariables = {
  chat_token_id: string,
  input: MonitorCheckResultLfInput,
};

export type CreateMonitorCheckResultLfMutation = {
  createMonitorCheckResultLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type IsEmailExistLfQueryVariables = {
  email?: string | null,
};

export type IsEmailExistLfQuery = {
  isEmailExistLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListAdminGroupUserLfQueryVariables = {
  id?: string | null,
};

export type ListAdminGroupUserLfQuery = {
  listAdminGroupUserLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetAdminUserLfQueryVariables = {
  user_id: string,
};

export type GetAdminUserLfQuery = {
  getAdminUserLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetGroupQueryVariables = {
  id: string,
};

export type GetGroupQuery = {
  getGroup?:  {
    __typename: "Group",
    id: string,
    name: string,
    memo?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListGroupsQueryVariables = {
  filter?: ModelGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGroupsQuery = {
  listGroups?:  {
    __typename: "ModelGroupConnection",
    items:  Array< {
      __typename: "Group",
      id: string,
      name: string,
      memo?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    group_id: string,
    name: string,
    email: string,
    role: ConsoleRoleType,
    is_personal_data_handler?: boolean | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      group_id: string,
      name: string,
      email: string,
      role: ConsoleRoleType,
      is_personal_data_handler?: boolean | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserByGroupQueryVariables = {
  group_id?: string | null,
  email?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserByGroupQuery = {
  listUserByGroup?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      group_id: string,
      name: string,
      email: string,
      role: ConsoleRoleType,
      is_personal_data_handler?: boolean | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSubjectQueryVariables = {
  id: string,
};

export type GetSubjectQuery = {
  getSubject?:  {
    __typename: "Subject",
    id: string,
    group_id: string,
    subject_seq: number,
    subject_number: string,
    subject_name?: string | null,
    subject_description?: string | null,
    subject_purpose?: string | null,
    interview_type?: InterviewType | null,
    start_date?: string | null,
    end_date?: string | null,
    input_expiration_date?: string | null,
    expiration_date?: string | null,
    main_user_id_group?: string | null,
    main_user_id_asmarq?: string | null,
    memo?: string | null,
    canceled: number,
    finished?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSubjectsQueryVariables = {
  filter?: ModelSubjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubjectsQuery = {
  listSubjects?:  {
    __typename: "ModelSubjectConnection",
    items:  Array< {
      __typename: "Subject",
      id: string,
      group_id: string,
      subject_seq: number,
      subject_number: string,
      subject_name?: string | null,
      subject_description?: string | null,
      subject_purpose?: string | null,
      interview_type?: InterviewType | null,
      start_date?: string | null,
      end_date?: string | null,
      input_expiration_date?: string | null,
      expiration_date?: string | null,
      main_user_id_group?: string | null,
      main_user_id_asmarq?: string | null,
      memo?: string | null,
      canceled: number,
      finished?: number | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSubjectSortBySeqQueryVariables = {
  group_id?: string | null,
  subject_seq?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSubjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubjectSortBySeqQuery = {
  listSubjectSortBySeq?:  {
    __typename: "ModelSubjectConnection",
    items:  Array< {
      __typename: "Subject",
      id: string,
      group_id: string,
      subject_seq: number,
      subject_number: string,
      subject_name?: string | null,
      subject_description?: string | null,
      subject_purpose?: string | null,
      interview_type?: InterviewType | null,
      start_date?: string | null,
      end_date?: string | null,
      input_expiration_date?: string | null,
      expiration_date?: string | null,
      main_user_id_group?: string | null,
      main_user_id_asmarq?: string | null,
      memo?: string | null,
      canceled: number,
      finished?: number | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSubjectSortByExpirationDateQueryVariables = {
  group_id?: string | null,
  expiration_date?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSubjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubjectSortByExpirationDateQuery = {
  listSubjectSortByExpirationDate?:  {
    __typename: "ModelSubjectConnection",
    items:  Array< {
      __typename: "Subject",
      id: string,
      group_id: string,
      subject_seq: number,
      subject_number: string,
      subject_name?: string | null,
      subject_description?: string | null,
      subject_purpose?: string | null,
      interview_type?: InterviewType | null,
      start_date?: string | null,
      end_date?: string | null,
      input_expiration_date?: string | null,
      expiration_date?: string | null,
      main_user_id_group?: string | null,
      main_user_id_asmarq?: string | null,
      memo?: string | null,
      canceled: number,
      finished?: number | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMarkedSubjectQueryVariables = {
  id: string,
};

export type GetMarkedSubjectQuery = {
  getMarkedSubject?:  {
    __typename: "MarkedSubject",
    id: string,
    user_id: string,
    subject_id: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMarkedSubjectsQueryVariables = {
  filter?: ModelMarkedSubjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMarkedSubjectsQuery = {
  listMarkedSubjects?:  {
    __typename: "ModelMarkedSubjectConnection",
    items:  Array< {
      __typename: "MarkedSubject",
      id: string,
      user_id: string,
      subject_id: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMarkedSubjectByUserIdQueryVariables = {
  user_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMarkedSubjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMarkedSubjectByUserIdQuery = {
  listMarkedSubjectByUserId?:  {
    __typename: "ModelMarkedSubjectConnection",
    items:  Array< {
      __typename: "MarkedSubject",
      id: string,
      user_id: string,
      subject_id: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMarkedSubjectBySubjectIdQueryVariables = {
  subject_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMarkedSubjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMarkedSubjectBySubjectIdQuery = {
  listMarkedSubjectBySubjectId?:  {
    __typename: "ModelMarkedSubjectConnection",
    items:  Array< {
      __typename: "MarkedSubject",
      id: string,
      user_id: string,
      subject_id: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetInterviewQueryVariables = {
  id: string,
};

export type GetInterviewQuery = {
  getInterview?:  {
    __typename: "Interview",
    id: string,
    subject_id: string,
    interview_seq: number,
    interview_type?: InterviewType | null,
    scheduled_start_date?: string | null,
    scheduled_end_date?: string | null,
    scheduled_start_time?: string | null,
    scheduled_end_time?: string | null,
    actual_start_date?: string | null,
    actual_end_date?: string | null,
    actual_start_time?: string | null,
    actual_end_time?: string | null,
    canceled: number,
    memo?: string | null,
    note?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListInterviewsQueryVariables = {
  filter?: ModelInterviewFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterviewsQuery = {
  listInterviews?:  {
    __typename: "ModelInterviewConnection",
    items:  Array< {
      __typename: "Interview",
      id: string,
      subject_id: string,
      interview_seq: number,
      interview_type?: InterviewType | null,
      scheduled_start_date?: string | null,
      scheduled_end_date?: string | null,
      scheduled_start_time?: string | null,
      scheduled_end_time?: string | null,
      actual_start_date?: string | null,
      actual_end_date?: string | null,
      actual_start_time?: string | null,
      actual_end_time?: string | null,
      canceled: number,
      memo?: string | null,
      note?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInterviewSortBySeqQueryVariables = {
  subject_id?: string | null,
  interview_seq?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInterviewFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterviewSortBySeqQuery = {
  listInterviewSortBySeq?:  {
    __typename: "ModelInterviewConnection",
    items:  Array< {
      __typename: "Interview",
      id: string,
      subject_id: string,
      interview_seq: number,
      interview_type?: InterviewType | null,
      scheduled_start_date?: string | null,
      scheduled_end_date?: string | null,
      scheduled_start_time?: string | null,
      scheduled_end_time?: string | null,
      actual_start_date?: string | null,
      actual_end_date?: string | null,
      actual_start_time?: string | null,
      actual_end_time?: string | null,
      canceled: number,
      memo?: string | null,
      note?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFileResourceQueryVariables = {
  id: string,
};

export type GetFileResourceQuery = {
  getFileResource?:  {
    __typename: "FileResource",
    id: string,
    subject_id: string,
    sort_index: number,
    file_name: string,
    title: string,
    type: ResourceType,
    url: string,
    description?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFileResourcesQueryVariables = {
  filter?: ModelFileResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFileResourcesQuery = {
  listFileResources?:  {
    __typename: "ModelFileResourceConnection",
    items:  Array< {
      __typename: "FileResource",
      id: string,
      subject_id: string,
      sort_index: number,
      file_name: string,
      title: string,
      type: ResourceType,
      url: string,
      description?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFileResourceSortBySortIndexQueryVariables = {
  subject_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFileResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFileResourceSortBySortIndexQuery = {
  listFileResourceSortBySortIndex?:  {
    __typename: "ModelFileResourceConnection",
    items:  Array< {
      __typename: "FileResource",
      id: string,
      subject_id: string,
      sort_index: number,
      file_name: string,
      title: string,
      type: ResourceType,
      url: string,
      description?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetScenarioQueryVariables = {
  id: string,
};

export type GetScenarioQuery = {
  getScenario?:  {
    __typename: "Scenario",
    id: string,
    subject_id: string,
    sort_index: number,
    scenario_no: number,
    template_no: number,
    text?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListScenariosQueryVariables = {
  filter?: ModelScenarioFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScenariosQuery = {
  listScenarios?:  {
    __typename: "ModelScenarioConnection",
    items:  Array< {
      __typename: "Scenario",
      id: string,
      subject_id: string,
      sort_index: number,
      scenario_no: number,
      template_no: number,
      text?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListScenarioSortBySortIndexQueryVariables = {
  subject_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelScenarioFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScenarioSortBySortIndexQuery = {
  listScenarioSortBySortIndex?:  {
    __typename: "ModelScenarioConnection",
    items:  Array< {
      __typename: "Scenario",
      id: string,
      subject_id: string,
      sort_index: number,
      scenario_no: number,
      template_no: number,
      text?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMonitorQueryVariables = {
  id: string,
};

export type GetMonitorQuery = {
  getMonitor?:  {
    __typename: "Monitor",
    id: string,
    subject_id: string,
    ans_id: string,
    classification?: string | null,
    member_id?: string | null,
    name?: string | null,
    sex?: string | null,
    age?: string | null,
    address?: string | null,
    marriage?: string | null,
    children?: string | null,
    job?: string | null,
    memo?: string | null,
    sort_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMonitorsQueryVariables = {
  filter?: ModelMonitorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorsQuery = {
  listMonitors?:  {
    __typename: "ModelMonitorConnection",
    items:  Array< {
      __typename: "Monitor",
      id: string,
      subject_id: string,
      ans_id: string,
      classification?: string | null,
      member_id?: string | null,
      name?: string | null,
      sex?: string | null,
      age?: string | null,
      address?: string | null,
      marriage?: string | null,
      children?: string | null,
      job?: string | null,
      memo?: string | null,
      sort_index?: number | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorSortByAnsIdQueryVariables = {
  subject_id?: string | null,
  ans_id?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorSortByAnsIdQuery = {
  listMonitorSortByAnsId?:  {
    __typename: "ModelMonitorConnection",
    items:  Array< {
      __typename: "Monitor",
      id: string,
      subject_id: string,
      ans_id: string,
      classification?: string | null,
      member_id?: string | null,
      name?: string | null,
      sex?: string | null,
      age?: string | null,
      address?: string | null,
      marriage?: string | null,
      children?: string | null,
      job?: string | null,
      memo?: string | null,
      sort_index?: number | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMonitorAssignQueryVariables = {
  id: string,
};

export type GetMonitorAssignQuery = {
  getMonitorAssign?:  {
    __typename: "MonitorAssign",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    pin?: string | null,
    last_entry_date?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMonitorAssignsQueryVariables = {
  filter?: ModelMonitorAssignFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorAssignsQuery = {
  listMonitorAssigns?:  {
    __typename: "ModelMonitorAssignConnection",
    items:  Array< {
      __typename: "MonitorAssign",
      id: string,
      subject_id: string,
      monitor_id: string,
      interview_id: string,
      pin?: string | null,
      last_entry_date?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorAssignBySubjectIdQueryVariables = {
  subject_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorAssignFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorAssignBySubjectIdQuery = {
  listMonitorAssignBySubjectId?:  {
    __typename: "ModelMonitorAssignConnection",
    items:  Array< {
      __typename: "MonitorAssign",
      id: string,
      subject_id: string,
      monitor_id: string,
      interview_id: string,
      pin?: string | null,
      last_entry_date?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorAssignByInterviewIdQueryVariables = {
  interview_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorAssignFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorAssignByInterviewIdQuery = {
  listMonitorAssignByInterviewId?:  {
    __typename: "ModelMonitorAssignConnection",
    items:  Array< {
      __typename: "MonitorAssign",
      id: string,
      subject_id: string,
      monitor_id: string,
      interview_id: string,
      pin?: string | null,
      last_entry_date?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorAssignByMonitorIdQueryVariables = {
  monitor_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorAssignFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorAssignByMonitorIdQuery = {
  listMonitorAssignByMonitorId?:  {
    __typename: "ModelMonitorAssignConnection",
    items:  Array< {
      __typename: "MonitorAssign",
      id: string,
      subject_id: string,
      monitor_id: string,
      interview_id: string,
      pin?: string | null,
      last_entry_date?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMonitorAttributeQueryVariables = {
  id: string,
};

export type GetMonitorAttributeQuery = {
  getMonitorAttribute?:  {
    __typename: "MonitorAttribute",
    id: string,
    subject_id: string,
    monitor_id: string,
    seq_no: number,
    name: string,
    value?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMonitorAttributesQueryVariables = {
  filter?: ModelMonitorAttributeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorAttributesQuery = {
  listMonitorAttributes?:  {
    __typename: "ModelMonitorAttributeConnection",
    items:  Array< {
      __typename: "MonitorAttribute",
      id: string,
      subject_id: string,
      monitor_id: string,
      seq_no: number,
      name: string,
      value?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSortMonitorAttributeBySeqNoQueryVariables = {
  monitor_id?: string | null,
  seq_no?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorAttributeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSortMonitorAttributeBySeqNoQuery = {
  listSortMonitorAttributeBySeqNo?:  {
    __typename: "ModelMonitorAttributeConnection",
    items:  Array< {
      __typename: "MonitorAttribute",
      id: string,
      subject_id: string,
      monitor_id: string,
      seq_no: number,
      name: string,
      value?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorAttributeBySubjectIdQueryVariables = {
  subject_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorAttributeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorAttributeBySubjectIdQuery = {
  listMonitorAttributeBySubjectId?:  {
    __typename: "ModelMonitorAttributeConnection",
    items:  Array< {
      __typename: "MonitorAttribute",
      id: string,
      subject_id: string,
      monitor_id: string,
      seq_no: number,
      name: string,
      value?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMonitorCheckResultQueryVariables = {
  id: string,
};

export type GetMonitorCheckResultQuery = {
  getMonitorCheckResult?:  {
    __typename: "MonitorCheckResult",
    id: string,
    monitor_id: string,
    subject_id: string,
    interview_id: string,
    initial_name?: string | null,
    initial_sex?: string | null,
    initial_age?: string | null,
    initial_address?: string | null,
    initial_marriage?: string | null,
    initial_children?: string | null,
    initial_job?: string | null,
    monitor_check_result_type?: MonitorCheckResultType | null,
    submitted_text?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMonitorCheckResultsQueryVariables = {
  filter?: ModelMonitorCheckResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorCheckResultsQuery = {
  listMonitorCheckResults?:  {
    __typename: "ModelMonitorCheckResultConnection",
    items:  Array< {
      __typename: "MonitorCheckResult",
      id: string,
      monitor_id: string,
      subject_id: string,
      interview_id: string,
      initial_name?: string | null,
      initial_sex?: string | null,
      initial_age?: string | null,
      initial_address?: string | null,
      initial_marriage?: string | null,
      initial_children?: string | null,
      initial_job?: string | null,
      monitor_check_result_type?: MonitorCheckResultType | null,
      submitted_text?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorCheckResultByMonitorIdQueryVariables = {
  monitor_id?: string | null,
  interview_id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorCheckResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorCheckResultByMonitorIdQuery = {
  listMonitorCheckResultByMonitorId?:  {
    __typename: "ModelMonitorCheckResultConnection",
    items:  Array< {
      __typename: "MonitorCheckResult",
      id: string,
      monitor_id: string,
      subject_id: string,
      interview_id: string,
      initial_name?: string | null,
      initial_sex?: string | null,
      initial_age?: string | null,
      initial_address?: string | null,
      initial_marriage?: string | null,
      initial_children?: string | null,
      initial_job?: string | null,
      monitor_check_result_type?: MonitorCheckResultType | null,
      submitted_text?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorCheckResultByInterviewIdQueryVariables = {
  interview_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorCheckResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorCheckResultByInterviewIdQuery = {
  listMonitorCheckResultByInterviewId?:  {
    __typename: "ModelMonitorCheckResultConnection",
    items:  Array< {
      __typename: "MonitorCheckResult",
      id: string,
      monitor_id: string,
      subject_id: string,
      interview_id: string,
      initial_name?: string | null,
      initial_sex?: string | null,
      initial_age?: string | null,
      initial_address?: string | null,
      initial_marriage?: string | null,
      initial_children?: string | null,
      initial_job?: string | null,
      monitor_check_result_type?: MonitorCheckResultType | null,
      submitted_text?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorCheckResultBySubjectIdQueryVariables = {
  subject_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorCheckResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorCheckResultBySubjectIdQuery = {
  listMonitorCheckResultBySubjectId?:  {
    __typename: "ModelMonitorCheckResultConnection",
    items:  Array< {
      __typename: "MonitorCheckResult",
      id: string,
      monitor_id: string,
      subject_id: string,
      interview_id: string,
      initial_name?: string | null,
      initial_sex?: string | null,
      initial_age?: string | null,
      initial_address?: string | null,
      initial_marriage?: string | null,
      initial_children?: string | null,
      initial_job?: string | null,
      monitor_check_result_type?: MonitorCheckResultType | null,
      submitted_text?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetChatDataQueryVariables = {
  id: string,
};

export type GetChatDataQuery = {
  getChatData?:  {
    __typename: "ChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    type?: ChatDataType | null,
    file_type?: ResourceType | null,
    text?: string | null,
    file_url?: string | null,
    mentioned_monitor_id_list?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    sort_index: number,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListChatDatasQueryVariables = {
  filter?: ModelChatDataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChatDatasQuery = {
  listChatDatas?:  {
    __typename: "ModelChatDataConnection",
    items:  Array< {
      __typename: "ChatData",
      id: string,
      subject_id: string,
      interview_id: string,
      type?: ChatDataType | null,
      file_type?: ResourceType | null,
      text?: string | null,
      file_url?: string | null,
      mentioned_monitor_id_list?: string | null,
      moderator_id?: string | null,
      monitor_id?: string | null,
      sort_index: number,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChatDataSortBySortIndexQueryVariables = {
  interview_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelChatDataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChatDataSortBySortIndexQuery = {
  listChatDataSortBySortIndex?:  {
    __typename: "ModelChatDataConnection",
    items:  Array< {
      __typename: "ChatData",
      id: string,
      subject_id: string,
      interview_id: string,
      type?: ChatDataType | null,
      file_type?: ResourceType | null,
      text?: string | null,
      file_url?: string | null,
      mentioned_monitor_id_list?: string | null,
      moderator_id?: string | null,
      monitor_id?: string | null,
      sort_index: number,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUsedResourceQueryVariables = {
  id: string,
};

export type GetUsedResourceQuery = {
  getUsedResource?:  {
    __typename: "UsedResource",
    id: string,
    subject_id: string,
    interview_id: string,
    type: UsedResourceType,
    key: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsedResourcesQueryVariables = {
  filter?: ModelUsedResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsedResourcesQuery = {
  listUsedResources?:  {
    __typename: "ModelUsedResourceConnection",
    items:  Array< {
      __typename: "UsedResource",
      id: string,
      subject_id: string,
      interview_id: string,
      type: UsedResourceType,
      key: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUsedResourcesBySubjectIdQueryVariables = {
  subject_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUsedResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsedResourcesBySubjectIdQuery = {
  listUsedResourcesBySubjectId?:  {
    __typename: "ModelUsedResourceConnection",
    items:  Array< {
      __typename: "UsedResource",
      id: string,
      subject_id: string,
      interview_id: string,
      type: UsedResourceType,
      key: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUsedResourcesByInterviewIdQueryVariables = {
  interview_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUsedResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsedResourcesByInterviewIdQuery = {
  listUsedResourcesByInterviewId?:  {
    __typename: "ModelUsedResourceConnection",
    items:  Array< {
      __typename: "UsedResource",
      id: string,
      subject_id: string,
      interview_id: string,
      type: UsedResourceType,
      key: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMonitorResourceQueryVariables = {
  id: string,
};

export type GetMonitorResourceQuery = {
  getMonitorResource?:  {
    __typename: "MonitorResource",
    id: string,
    subject_id: string,
    monitor_id: string,
    interview_id: string,
    sort_index: number,
    file_name: string,
    type: ResourceType,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMonitorResourcesQueryVariables = {
  filter?: ModelMonitorResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorResourcesQuery = {
  listMonitorResources?:  {
    __typename: "ModelMonitorResourceConnection",
    items:  Array< {
      __typename: "MonitorResource",
      id: string,
      subject_id: string,
      monitor_id: string,
      interview_id: string,
      sort_index: number,
      file_name: string,
      type: ResourceType,
      url: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMonitorResourceSortBySortIndexQueryVariables = {
  interview_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMonitorResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonitorResourceSortBySortIndexQuery = {
  listMonitorResourceSortBySortIndex?:  {
    __typename: "ModelMonitorResourceConnection",
    items:  Array< {
      __typename: "MonitorResource",
      id: string,
      subject_id: string,
      monitor_id: string,
      interview_id: string,
      sort_index: number,
      file_name: string,
      type: ResourceType,
      url: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetInterviewResourceQueryVariables = {
  id: string,
};

export type GetInterviewResourceQuery = {
  getInterviewResource?:  {
    __typename: "InterviewResource",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    chat_data_id?: string | null,
    type: ResourceType,
    title?: string | null,
    description?: string | null,
    file_name: string,
    url: string,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListInterviewResourcesQueryVariables = {
  filter?: ModelInterviewResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterviewResourcesQuery = {
  listInterviewResources?:  {
    __typename: "ModelInterviewResourceConnection",
    items:  Array< {
      __typename: "InterviewResource",
      id: string,
      subject_id: string,
      interview_id: string,
      sort_index: number,
      chat_data_id?: string | null,
      type: ResourceType,
      title?: string | null,
      description?: string | null,
      file_name: string,
      url: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInterviewResourceSortBySortIndexQueryVariables = {
  interview_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInterviewResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterviewResourceSortBySortIndexQuery = {
  listInterviewResourceSortBySortIndex?:  {
    __typename: "ModelInterviewResourceConnection",
    items:  Array< {
      __typename: "InterviewResource",
      id: string,
      subject_id: string,
      interview_id: string,
      sort_index: number,
      chat_data_id?: string | null,
      type: ResourceType,
      title?: string | null,
      description?: string | null,
      file_name: string,
      url: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInterviewResourceBySubjectIdQueryVariables = {
  subject_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInterviewResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterviewResourceBySubjectIdQuery = {
  listInterviewResourceBySubjectId?:  {
    __typename: "ModelInterviewResourceConnection",
    items:  Array< {
      __typename: "InterviewResource",
      id: string,
      subject_id: string,
      interview_id: string,
      sort_index: number,
      chat_data_id?: string | null,
      type: ResourceType,
      title?: string | null,
      description?: string | null,
      file_name: string,
      url: string,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetChatTokenQueryVariables = {
  id: string,
};

export type GetChatTokenQuery = {
  getChatToken?:  {
    __typename: "ChatToken",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    last_event_dates_id?: string | null,
    last_event_dates_updatedAt?: string | null,
    typing_chat_data_id?: string | null,
    read_index_id?: string | null,
    refreshed_at?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListChatTokensQueryVariables = {
  filter?: ModelChatTokenFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChatTokensQuery = {
  listChatTokens?:  {
    __typename: "ModelChatTokenConnection",
    items:  Array< {
      __typename: "ChatToken",
      id: string,
      subject_id: string,
      interview_id: string,
      moderator_id?: string | null,
      monitor_id?: string | null,
      last_event_dates_id?: string | null,
      last_event_dates_updatedAt?: string | null,
      typing_chat_data_id?: string | null,
      read_index_id?: string | null,
      refreshed_at?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChatTokenByInterviewIdQueryVariables = {
  interview_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelChatTokenFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChatTokenByInterviewIdQuery = {
  listChatTokenByInterviewId?:  {
    __typename: "ModelChatTokenConnection",
    items:  Array< {
      __typename: "ChatToken",
      id: string,
      subject_id: string,
      interview_id: string,
      moderator_id?: string | null,
      monitor_id?: string | null,
      last_event_dates_id?: string | null,
      last_event_dates_updatedAt?: string | null,
      typing_chat_data_id?: string | null,
      read_index_id?: string | null,
      refreshed_at?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListChatTokenByModeratorIdSortByCreatedAtQueryVariables = {
  moderator_id?: string | null,
  interview_idCreatedAt?: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelChatTokenFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChatTokenByModeratorIdSortByCreatedAtQuery = {
  listChatTokenByModeratorIdSortByCreatedAt?:  {
    __typename: "ModelChatTokenConnection",
    items:  Array< {
      __typename: "ChatToken",
      id: string,
      subject_id: string,
      interview_id: string,
      moderator_id?: string | null,
      monitor_id?: string | null,
      last_event_dates_id?: string | null,
      last_event_dates_updatedAt?: string | null,
      typing_chat_data_id?: string | null,
      read_index_id?: string | null,
      refreshed_at?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLastEventDatesQueryVariables = {
  id: string,
};

export type GetLastEventDatesQuery = {
  getLastEventDates?:  {
    __typename: "LastEventDates",
    id: string,
    chat_created?: string | null,
    monitor_typing?: string | null,
    moderator_read?: string | null,
    monitor_read?: string | null,
    interviewer_announce?: string | null,
    chat_token_id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLastEventDatessQueryVariables = {
  filter?: ModelLastEventDatesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLastEventDatessQuery = {
  listLastEventDatess?:  {
    __typename: "ModelLastEventDatesConnection",
    items:  Array< {
      __typename: "LastEventDates",
      id: string,
      chat_created?: string | null,
      monitor_typing?: string | null,
      moderator_read?: string | null,
      monitor_read?: string | null,
      interviewer_announce?: string | null,
      chat_token_id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLastEventDatesByChatTokenIdQueryVariables = {
  chat_token_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLastEventDatesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLastEventDatesByChatTokenIdQuery = {
  listLastEventDatesByChatTokenId?:  {
    __typename: "ModelLastEventDatesConnection",
    items:  Array< {
      __typename: "LastEventDates",
      id: string,
      chat_created?: string | null,
      monitor_typing?: string | null,
      moderator_read?: string | null,
      monitor_read?: string | null,
      interviewer_announce?: string | null,
      chat_token_id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLastChatSortIndexQueryVariables = {
  id: string,
};

export type GetLastChatSortIndexQuery = {
  getLastChatSortIndex?:  {
    __typename: "LastChatSortIndex",
    id: string,
    interview_id: string,
    chat_sort_index: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLastChatSortIndexsQueryVariables = {
  filter?: ModelLastChatSortIndexFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLastChatSortIndexsQuery = {
  listLastChatSortIndexs?:  {
    __typename: "ModelLastChatSortIndexConnection",
    items:  Array< {
      __typename: "LastChatSortIndex",
      id: string,
      interview_id: string,
      chat_sort_index: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLastChatSortIndexByInterviewIdQueryVariables = {
  interview_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLastChatSortIndexFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLastChatSortIndexByInterviewIdQuery = {
  listLastChatSortIndexByInterviewId?:  {
    __typename: "ModelLastChatSortIndexConnection",
    items:  Array< {
      __typename: "LastChatSortIndex",
      id: string,
      interview_id: string,
      chat_sort_index: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTypingChatDataQueryVariables = {
  id: string,
};

export type GetTypingChatDataQuery = {
  getTypingChatData?:  {
    __typename: "TypingChatData",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    moderator_id?: string | null,
    monitor_id?: string | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTypingChatDatasQueryVariables = {
  filter?: ModelTypingChatDataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTypingChatDatasQuery = {
  listTypingChatDatas?:  {
    __typename: "ModelTypingChatDataConnection",
    items:  Array< {
      __typename: "TypingChatData",
      id: string,
      subject_id: string,
      interview_id: string,
      text?: string | null,
      moderator_id?: string | null,
      monitor_id?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTypingChatDataSortByInterviewIdQueryVariables = {
  interview_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTypingChatDataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTypingChatDataSortByInterviewIdQuery = {
  listTypingChatDataSortByInterviewId?:  {
    __typename: "ModelTypingChatDataConnection",
    items:  Array< {
      __typename: "TypingChatData",
      id: string,
      subject_id: string,
      interview_id: string,
      text?: string | null,
      moderator_id?: string | null,
      monitor_id?: string | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetReadIndexQueryVariables = {
  id: string,
};

export type GetReadIndexQuery = {
  getReadIndex?:  {
    __typename: "ReadIndex",
    id: string,
    subject_id: string,
    interview_id: string,
    moderator_id?: string | null,
    monitor_id?: string | null,
    read_index?: number | null,
    groups?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReadIndexsQueryVariables = {
  filter?: ModelReadIndexFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReadIndexsQuery = {
  listReadIndexs?:  {
    __typename: "ModelReadIndexConnection",
    items:  Array< {
      __typename: "ReadIndex",
      id: string,
      subject_id: string,
      interview_id: string,
      moderator_id?: string | null,
      monitor_id?: string | null,
      read_index?: number | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReadIndexSortByInterviewIdQueryVariables = {
  interview_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReadIndexFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReadIndexSortByInterviewIdQuery = {
  listReadIndexSortByInterviewId?:  {
    __typename: "ModelReadIndexConnection",
    items:  Array< {
      __typename: "ReadIndex",
      id: string,
      subject_id: string,
      interview_id: string,
      moderator_id?: string | null,
      monitor_id?: string | null,
      read_index?: number | null,
      groups?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetInterviewerAnnounceQueryVariables = {
  id: string,
};

export type GetInterviewerAnnounceQuery = {
  getInterviewerAnnounce?:  {
    __typename: "InterviewerAnnounce",
    id: string,
    subject_id: string,
    interview_id: string,
    text?: string | null,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListInterviewerAnnouncesQueryVariables = {
  filter?: ModelInterviewerAnnounceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterviewerAnnouncesQuery = {
  listInterviewerAnnounces?:  {
    __typename: "ModelInterviewerAnnounceConnection",
    items:  Array< {
      __typename: "InterviewerAnnounce",
      id: string,
      subject_id: string,
      interview_id: string,
      text?: string | null,
      sort_index: number,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListInterviewerAnnounceByInterviewIdSortBySortIndexQueryVariables = {
  interview_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelInterviewerAnnounceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterviewerAnnounceByInterviewIdSortBySortIndexQuery = {
  listInterviewerAnnounceByInterviewIdSortBySortIndex?:  {
    __typename: "ModelInterviewerAnnounceConnection",
    items:  Array< {
      __typename: "InterviewerAnnounce",
      id: string,
      subject_id: string,
      interview_id: string,
      text?: string | null,
      sort_index: number,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNotificationEventQueryVariables = {
  id: string,
};

export type GetNotificationEventQuery = {
  getNotificationEvent?:  {
    __typename: "NotificationEvent",
    id: string,
    subject_id: string,
    interview_id: string,
    sort_index: number,
    groups: string,
    notification_event_type?: NotificationEventType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListNotificationEventsQueryVariables = {
  filter?: ModelNotificationEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationEventsQuery = {
  listNotificationEvents?:  {
    __typename: "ModelNotificationEventConnection",
    items:  Array< {
      __typename: "NotificationEvent",
      id: string,
      subject_id: string,
      interview_id: string,
      sort_index: number,
      groups: string,
      notification_event_type?: NotificationEventType | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListNotificationEventByInterviewIdSortBySortIndexQueryVariables = {
  interview_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationEventByInterviewIdSortBySortIndexQuery = {
  listNotificationEventByInterviewIdSortBySortIndex?:  {
    __typename: "ModelNotificationEventConnection",
    items:  Array< {
      __typename: "NotificationEvent",
      id: string,
      subject_id: string,
      interview_id: string,
      sort_index: number,
      groups: string,
      notification_event_type?: NotificationEventType | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMailQueryVariables = {
  id: string,
};

export type GetMailQuery = {
  getMail?:  {
    __typename: "Mail",
    id: string,
    subject_id: string,
    interview_id: string,
    monitor_id: string,
    heading: string,
    message: string,
    send_status: SendStatus,
    notification_event_id: string,
    sort_index: number,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMailsQueryVariables = {
  filter?: ModelMailFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMailsQuery = {
  listMails?:  {
    __typename: "ModelMailConnection",
    items:  Array< {
      __typename: "Mail",
      id: string,
      subject_id: string,
      interview_id: string,
      monitor_id: string,
      heading: string,
      message: string,
      send_status: SendStatus,
      notification_event_id: string,
      sort_index: number,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMailByInterviewIdSortBySortIndexQueryVariables = {
  interview_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMailFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMailByInterviewIdSortBySortIndexQuery = {
  listMailByInterviewIdSortBySortIndex?:  {
    __typename: "ModelMailConnection",
    items:  Array< {
      __typename: "Mail",
      id: string,
      subject_id: string,
      interview_id: string,
      monitor_id: string,
      heading: string,
      message: string,
      send_status: SendStatus,
      notification_event_id: string,
      sort_index: number,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMailByMonitorIdQueryVariables = {
  monitor_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMailFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMailByMonitorIdQuery = {
  listMailByMonitorId?:  {
    __typename: "ModelMailConnection",
    items:  Array< {
      __typename: "Mail",
      id: string,
      subject_id: string,
      interview_id: string,
      monitor_id: string,
      heading: string,
      message: string,
      send_status: SendStatus,
      notification_event_id: string,
      sort_index: number,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMailByNotificationEventIdSortBySortIndexQueryVariables = {
  notification_event_id?: string | null,
  sort_index?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMailFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMailByNotificationEventIdSortBySortIndexQuery = {
  listMailByNotificationEventIdSortBySortIndex?:  {
    __typename: "ModelMailConnection",
    items:  Array< {
      __typename: "Mail",
      id: string,
      subject_id: string,
      interview_id: string,
      monitor_id: string,
      heading: string,
      message: string,
      send_status: SendStatus,
      notification_event_id: string,
      sort_index: number,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEmailQueryVariables = {
  monitor_id: string,
};

export type GetEmailQuery = {
  getEmail?:  {
    __typename: "Email",
    id: string,
    monitor_id: string,
    subject_id: string,
    email: string,
    groups: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEmailsQueryVariables = {
  monitor_id?: string | null,
  filter?: ModelEmailFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEmailsQuery = {
  listEmails?:  {
    __typename: "ModelEmailConnection",
    items:  Array< {
      __typename: "Email",
      id: string,
      monitor_id: string,
      subject_id: string,
      email: string,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEmailBySubjectIdQueryVariables = {
  subject_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmailFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEmailBySubjectIdQuery = {
  listEmailBySubjectId?:  {
    __typename: "ModelEmailConnection",
    items:  Array< {
      __typename: "Email",
      id: string,
      monitor_id: string,
      subject_id: string,
      email: string,
      groups: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SendConfirmationCodeLfQueryVariables = {
  email: string,
};

export type SendConfirmationCodeLfQuery = {
  sendConfirmationCodeLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type SetPasswordLfQueryVariables = {
  email: string,
  confirmation_code: string,
  password: string,
};

export type SetPasswordLfQuery = {
  setPasswordLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetAttendeeRoleLfQueryVariables = {
  attendee_id?: string | null,
};

export type GetAttendeeRoleLfQuery = {
  getAttendeeRoleLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetMonitorByMonitorAssignIdLfQueryVariables = {
  monitor_assign_id?: string | null,
};

export type GetMonitorByMonitorAssignIdLfQuery = {
  getMonitorByMonitorAssignIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetMonitorForTestEntryLfQueryVariables = {
  chat_token_id?: string | null,
};

export type GetMonitorForTestEntryLfQuery = {
  getMonitorForTestEntryLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetMonitorAssignByMonitorIdLfQueryVariables = {
  chat_token_id: string,
  monitor_id?: string | null,
};

export type GetMonitorAssignByMonitorIdLfQuery = {
  getMonitorAssignByMonitorIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetInterviewByMonitorAssignIdLfQueryVariables = {
  monitor_assign_id?: string | null,
};

export type GetInterviewByMonitorAssignIdLfQuery = {
  getInterviewByMonitorAssignIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetModeratorChatTokenLfQueryVariables = {
  moderator_id: string,
  interview_id: string,
};

export type GetModeratorChatTokenLfQuery = {
  getModeratorChatTokenLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type IsCorrectPinCodeLfQueryVariables = {
  monitor_assign_id: string,
  pin_code?: string | null,
};

export type IsCorrectPinCodeLfQuery = {
  isCorrectPinCodeLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetSubjectLfQueryVariables = {
  chat_token_id: string,
};

export type GetSubjectLfQuery = {
  getSubjectLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type GetInterviewLfQueryVariables = {
  chat_token_id: string,
};

export type GetInterviewLfQuery = {
  getInterviewLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListMonitorByInterviewIdLfQueryVariables = {
  chat_token_id: string,
};

export type ListMonitorByInterviewIdLfQuery = {
  listMonitorByInterviewIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListMonitorCheckResultByMonitorIdLfQueryVariables = {
  chat_token_id: string,
};

export type ListMonitorCheckResultByMonitorIdLfQuery = {
  listMonitorCheckResultByMonitorIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListMonitorAttributeLfQueryVariables = {
  chat_token_id: string,
  monitor_id: string,
};

export type ListMonitorAttributeLfQuery = {
  listMonitorAttributeLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListChatDataByChatTokenIdLfQueryVariables = {
  chat_token_id: string,
  sort_index: number,
};

export type ListChatDataByChatTokenIdLfQuery = {
  listChatDataByChatTokenIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListScenarioBySubjectIdLfQueryVariables = {
  chat_token_id: string,
};

export type ListScenarioBySubjectIdLfQuery = {
  listScenarioBySubjectIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListUsedResourcesByInterviewIdLfQueryVariables = {
  chat_token_id: string,
};

export type ListUsedResourcesByInterviewIdLfQuery = {
  listUsedResourcesByInterviewIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListFileResourcesBySubjectIdLfQueryVariables = {
  chat_token_id: string,
};

export type ListFileResourcesBySubjectIdLfQuery = {
  listFileResourcesBySubjectIdLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListMonitorTypingChatDataLfQueryVariables = {
  chat_token_id: string,
};

export type ListMonitorTypingChatDataLfQuery = {
  listMonitorTypingChatDataLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListModeratorReadIndexLfQueryVariables = {
  chat_token_id: string,
};

export type ListModeratorReadIndexLfQuery = {
  listModeratorReadIndexLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListMonitorReadIndexLfQueryVariables = {
  chat_token_id: string,
};

export type ListMonitorReadIndexLfQuery = {
  listMonitorReadIndexLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type ListInterviewerAnnounceLfQueryVariables = {
  chat_token_id: string,
  sort_index: number,
};

export type ListInterviewerAnnounceLfQuery = {
  listInterviewerAnnounceLf?:  {
    __typename: "Response",
    statusCode: string,
    headers?: string | null,
    body?: string | null,
    isBase64Encoded?: string | null,
  } | null,
};

export type OnLastEventDatesUpdatedSubscriptionVariables = {
  chat_token_id: string,
};

export type OnLastEventDatesUpdatedSubscription = {
  onLastEventDatesUpdated?:  {
    __typename: "LastEventDates",
    id: string,
    chat_created?: string | null,
    monitor_typing?: string | null,
    moderator_read?: string | null,
    monitor_read?: string | null,
    interviewer_announce?: string | null,
    chat_token_id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};
